webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Helpers = {
  isMobile: function isMobile() {
    var check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  },
  isTouch: function isTouch() {
    var isMobile = false; //initiate as false
    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
    return isMobile;
  },
  iOS: function iOS() {
    var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()) {
        return true;
      }
    }

    return false;
  },
  isIPAD: function isIPAD() {
    var ua = navigator.userAgent;
    return (/iPad/i.test(ua) || /iPhone OS 3_1_2/i.test(ua) || /iPhone OS 3_2_2/i.test(ua)
    );
  },
  get_browser_info: function get_browser_info() {
    var ua = navigator.userAgent,
        tem = void 0,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: tem[1] || '' };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem !== null) {
        return { name: 'Opera', version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1]
    };
  },
  setVideoSize: function setVideoSize(v) {
    var self = this;
    var windowWidth = document.documentElement.clientWidth,
        windowHeight = document.documentElement.clientHeight,
        vW = v.videoWidth,
        vH = v.videoHeight;

    var rW = void 0,
        rH = void 0;

    var videoAspectRatio = vH / vW,
        windowAspectRatio = windowHeight / windowWidth;

    if (!self.isIE()) {
      return;
    } else {
      if (windowAspectRatio < videoAspectRatio) {
        rW = windowWidth + 50;
        rH = (windowWidth + 50) * videoAspectRatio;
      } else {
        rH = windowHeight + 50;
        rW = (windowHeight + 50) / videoAspectRatio;
      }
    }

    v.style.width = rW + 'px';
    v.style.height = rH + 'px';
  },
  getRandomInt: function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  },
  getRandomFromArray: function getRandomFromArray(array) {
    return array[getRandomInt(0, array.length - 1)];
  },
  declension: function declension(num, expressions) {
    var result = void 0;
    var count = num % 100;
    if (count >= 5 && count <= 20) {
      result = expressions['2'];
    } else {
      count = count % 10;
      if (count === 1) {
        result = expressions['0'];
      } else if (count >= 2 && count <= 4) {
        result = expressions['1'];
      } else {
        result = expressions['2'];
      }
    }
    return result;
  },
  isIE: function isIE() {
    var ua = window.navigator.userAgent;
    return ua.indexOf('Edge/') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0;
  },
  ga: function (_ga) {
    function ga() {
      return _ga.apply(this, arguments);
    }

    ga.toString = function () {
      return _ga.toString();
    };

    return ga;
  }(function () {
    var analitics = {
      send: function send(category, action, label, id) {
        console.log('send', category, action, label);
        if (typeof ga !== 'undefined') {
          if (typeof label !== 'undefined' && label !== '') {
            if (id) ga('send', 'event', category, action, label, id);else ga('send', 'event', category, action, label);
          } else {
            ga('send', 'event', category, action);
          }
        }
      }
    };
    return analitics;
  }),
  share: function share(network, link, callback) {
    switch (network) {
      case "vk":
        sharePopup("https://vk.com/share.php?url=" + link, 550, 300, callback);
        break;
      case "fb":
        sharePopup('https://www.facebook.com/sharer/sharer.php?u=' + link, 550, 300, callback);
        break;
      case "tw":
        sharePopup("https://twitter.com/intent/tweet?original_referer=" + link + "&tw_p=tweetbutton&url=" + link, 550, 300, callback);
        break;
      case "ok":
        sharePopup("https://connect.ok.ru/dk?cmd=WidgetSharePreview&st.cmd=WidgetSharePreview&st._aid=ExternalShareWidget_SharePreview&st.shareUrl=" + link, 550, 300, callback);
        break;
      case "tg":
        sharePopup("https://telegram.me/share/url?url=" + link, 550, 300, callback);
        break;
    }

    function sharePopup(url, width, height, callback) {
      //  console.log(url);
      if (!width) width = 400;
      if (!height) height = 400;

      var share_window = window.open(url, '_blank', 'height=' + height + ',width=' + width + ',menubar=no,toolbar=no,location=no');
      var uri_regex = new RegExp(document.location.host);
      //console.log('document.location.host',document.location.host)
      var watch_timer = setInterval(function () {
        try {
          if (share_window.closed) {
            clearInterval(watch_timer);
            onShare();
            return;
          }
          // console.log('share_window.location',share_window.location)
          if (uri_regex.test(share_window.location)) {
            clearInterval(watch_timer);
            share_window.closed;
            share_window.close();
            if (typeof callback !== 'undefined') {
              callback();
            }
          }
        } catch (e) {}
      }, 200);
    }
  },

  isScrolledIntoView: function isScrolledIntoView(el) {
    var elemTop = el.getBoundingClientRect().top;
    var elemBottom = el.getBoundingClientRect().bottom;
    var elHeight = elemBottom - elemTop;
    //return (elemTop >= -window.innerHeight/2) && (elemTop <= window.innerHeight/2) && (elemBottom >= window.innerHeight/2) && (elemBottom <= 3*window.innerHeight/2);
    return elemBottom <= elHeight;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Helpers);

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 67"><path class="st0" d="M33.5 0C15 0 0 15 0 33.5S15 67 33.5 67 67 52 67 33.5 52 0 33.5 0M42 21.6h-3.2c-2.3 0-2.5.9-2.5 2.5v3.1H42l-.7 6.3h-5v18.2h-7.5V33.6H25v-6.3h3.8v-3.8c0-5.2 2.2-8.2 8.2-8.2h5v6.3z"/></svg>'};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 46"><path d="M24 .038l8 14.3 16 3.2-11.1 12.1 1.9 16.3-14.8-6.8-14.8 6.9 1.9-16.3L0 17.538l16-3.2 8-14.3z"/></svg>'};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path class="st0" d="M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24 24-10.7 24-24S37.3 0 24 0m10 18.6v.7c0 7.5-5.3 16.1-15 16.1-3 0-5.8-1-8.1-2.6.5.1.9.1 1.3.1 2.4 0 4.7-.9 6.5-2.4-2.3 0-4.2-1.6-4.9-3.9.3.1.7.1 1 .1.5 0 1-.1 1.4-.2-2.4-.6-4.2-2.9-4.2-5.6v-.1c.7.4 1.5.7 2.4.7-1.4-1-2.3-2.7-2.3-4.7 0-1.1.2-2.1.7-2.9 2.6 3.4 6.5 5.7 10.9 5.9-.1-.4-.1-.9-.1-1.3 0-3.2 2.4-5.7 5.3-5.7 1.5 0 2.8.7 3.8 1.8 1.3-.3 2.4-.8 3.4-1.4-.4 1.3-1.2 2.4-2.3 3.1 1-.1 2.1-.4 3-.9-.7 1.2-1.6 2.2-2.8 3.2"/></svg>'};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.2 112.2"><path class="st0" d="M56.1 0C25.1 0 0 25.1 0 56.1s25.1 56.1 56.1 56.1 56.1-25.1 56.1-56.1S87.1 0 56.1 0m32.1 80.7l-9.8.1s-2.1.4-4.9-1.5c-3.7-2.5-7.2-9.1-9.9-8.2-2.7.9-2.6 6.8-2.6 6.8s0 1.3-.6 1.9c-.7.7-2 .9-2 .9H54s-9.7.6-18.3-8.3c-9.3-9.7-17.6-29-17.6-29s-.5-1.3 0-1.9c.6-.7 2.2-.7 2.2-.7l10.5-.1s1 .2 1.7.7c.6.4.9 1.2.9 1.2s1.7 4.3 4 8.2c4.4 7.6 6.4 9.3 7.9 8.4 2.2-1.2 1.5-10.7 1.5-10.7s0-3.5-1.1-5c-.9-1.2-2.5-1.5-3.3-1.6-.6-.1.4-1.5 1.6-2.1 1.9-.9 5.2-1 9.2-.9 3.1 0 4 .2 5.2.5 3.6.9 2.4 4.3 2.4 12.4 0 2.6-.5 6.3 1.4 7.5.8.5 2.8.1 7.7-8.3 2.3-4 4.1-8.6 4.1-8.6s.4-.8 1-1.2c.6-.4 1.4-.3 1.4-.3l11.1-.1s3.3-.4 3.9 1.1c.6 1.6-1.2 5.3-5.8 11.3-7.4 9.9-8.3 9-2.1 14.7 5.9 5.5 7.1 8.1 7.3 8.5 2.6 4-2.6 4.3-2.6 4.3"/></svg>'};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_user__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_test__ = __webpack_require__(216);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.credentials = true;

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        user: __WEBPACK_IMPORTED_MODULE_6__modules_user__["a" /* default */],
        test: __WEBPACK_IMPORTED_MODULE_7__modules_test__["a" /* default */]
    },
    state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* state */],
    getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
// Default State

var IS_LOCAL = location.href.indexOf('localhost') >= 0 || location.href.indexOf('192.168') >= 0;
var API_URL = 'http://dev-fifa18.devup.cc';

var state = {
    currentId: 0,
    animatedLoad: false,
    animated: false,
    uiShow: false,
    handleBlock: true,
    popup: { name: false },
    urlRoot: IS_LOCAL ? API_URL : ''
};

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(494),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(508),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(498),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(501),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-480d9b5e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(502),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b89ca33",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-83cbb2ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(504),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91 91"><path d="M45.5 0C20.4 0 0 20.4 0 45.5S20.4 91 45.5 91 91 70.6 91 45.5 70.6 0 45.5 0zm0 84C24.3 84 7 66.7 7 45.5S24.3 7 45.5 7 84 24.3 84 45.5 66.7 84 45.5 84zm0-73.2c-1.9 0-3.5 1.6-3.5 3.5V44L25.9 59.5c-1.4 1.3-1.4 3.6-.1 4.9.7.7 1.6 1.1 2.5 1.1.9 0 1.7-.3 2.4-1L47.9 48c.7-.7 1.1-1.6 1.1-2.5V14.3c0-1.9-1.6-3.5-3.5-3.5z"/></svg>'};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 88.2 87.2"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10"><path d="M17.3 2.6L71 2.5c0 25.9-18.9 50.8-18.9 50.8H36.2s-18.9-25-18.9-50.7z" clip-path="url(#SVGID_2_)" stroke-width="5" stroke-linejoin="round"/><path clip-path="url(#SVGID_2_)" stroke-width="5" d="M36.2 53.3h15.9M53.1 68.3H35.2M40.1 71.2V55.3M48.1 71.2V55.3M56 84.7H32.3c-2.3 0-4.1-1.3-4.1-3l1-6.6c0-1.6 1.8-3 4.1-3H55c2.3 0 4.1 1.3 4.1 3l1 6.6c0 1.7-1.9 3-4.1 3z"/><path d="M13.6 16.9s5.7-3 3.7-8.6C15.4 2.6 8.6 4 8.6 4S2 5.9 2 12.5c0 9.2 18.5 23.9 20.3 25s5.3 4.1 6.8 5.6 3.5 5.7-2.8 6M74.6 16.9s-5.7-3-3.7-8.6S79.6 4 79.6 4s6.6 1.9 6.6 8.5c0 9.2-18.5 23.9-20.3 25s-5.3 4.1-6.8 5.6-3.5 5.7 2.8 6" clip-path="url(#SVGID_2_)" stroke-width="4" stroke-linejoin="round"/></g></svg>'};

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 58.37132 89.01192"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="4" d="M29.186 0v84.375"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="3" d="M57.311 58.766L29.186 86.891 1.061 58.766"/></svg>'};

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuebar__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_youtube__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_youtube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_youtube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_hammer__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_scss_app_scss__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_scss_app_scss__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
__webpack_require__(456);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuebar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_youtube___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue2_hammer__["a" /* VueHammer */]);

var initialize = function initialize() {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
        el: '#app',
        store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
        router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
        template: '<App/>',
        created: function created() {
            window.vue = this;
        },

        components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
    });
};

__WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('getUser').then(function () {
    initialize();
}, function () {
    initialize();
});

__WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('getCurrentWeek');

/***/ }),
/* 185 */,
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(171);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Resize__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_Header__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_parts_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_Footer__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_parts_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_landing__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_popups_BasePopup__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_popups_BasePopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_popups_BasePopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var PAGES = ['Index', 'Rules'];

var lastScrollTime = new Date().getTime();

var LandingRoutes = ['Rules', 'Test', 'Video', 'Product'];

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		Resize: __WEBPACK_IMPORTED_MODULE_0__components_common_Resize___default.a,
		HeaderComponent: __WEBPACK_IMPORTED_MODULE_1__components_parts_Header___default.a,
		FooterComponent: __WEBPACK_IMPORTED_MODULE_2__components_parts_Footer___default.a,
		landing: __WEBPACK_IMPORTED_MODULE_3__components_pages_landing___default.a,
		BasePopup: __WEBPACK_IMPORTED_MODULE_4__components_popups_BasePopup___default.a,
		Helpers: __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__["a" /* default */]
	},
	watch: {
		'$route.name': function $routeName(val) {
			__WEBPACK_IMPORTED_MODULE_5__tools_Helpers__["a" /* default */].ga().send('click', 'Страница ' + val);
		}
	},
	data: function data() {
		return {
			Helpers: __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__["a" /* default */],
			transitionName: 'fade'
		};
	},

	computed: {
		popup: function popup() {
			return this.$store.getters['GET_POPUP'];
		},
		isLandingPage: function isLandingPage() {
			return LandingRoutes.indexOf(this.$route.name) >= 0;
		},
		routeName: function routeName() {
			return this.$route.name;
		},
		canScroll: function canScroll() {
			return this.$store.getters['GET_LOAD_ANIMATE'];
		},
		animated: function animated() {
			return this.$store.getters['GET_ANIMATED'];
		}
	},

	methods: {
		onMouseWheel: function onMouseWheel(e) {
			var scrollTime = new Date().getTime();
			var lScroll = lastScrollTime;
			lastScrollTime = scrollTime;

			if (!this.animated) {
				return;
			}
			if (scrollTime - lScroll < 250) return;

			var delta = e.deltaY || e.detail || e.wheelDelta;
			if (delta > 0) {
				this.nextPage();
			} else {
				this.prevPage();
			}
		},
		nextPage: function nextPage() {
			var index = PAGES.indexOf(this.routeName) + 1;
			var next = typeof PAGES[index] !== 'undefined' ? PAGES[index] : false;

			if (next && index) {
				console.log(index, next);
				this.$router.push({ name: next });
			}
		},
		prevPage: function prevPage() {
			var index = PAGES.indexOf(this.routeName) - 1;
			var prev = typeof PAGES[index] !== 'undefined' ? PAGES[index] : false;

			if (prev) {
				this.$router.push({ name: prev });
			}
		}
	}
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'CoverContainer',
	mounted: function mounted() {
		var _this = this;

		this.slotEl = this.$slots.default[0].elm;
		this.slotEl.style.position = 'absolute';
		this.slotEl.style.left = '50%';
		this.slotEl.style.top = '50%';
		this.slotEl.style.transform = 'translate3d(-50%,-50%,0)';
		window.addEventListener('resize', function () {
			_this.doCover();
		});
		this.doCover();

		this.slotEl.addEventListener('loadedmetadata', function () {
			_this.doCover();
		});
		//      this.slotEl.addEventListener('playing', ()=>{
		//          this.doCover();
		//      });
	},

	methods: {
		doCover: function doCover() {
			var el = this.slotEl;
			var st = getComputedStyle(this.$el);
			var cntWidth = parseInt(st.width),
			    cntHeight = parseInt(st.height),
			    vW = el.videoWidth,
			    vH = el.videoHeight;
			console.log(this.$el);
			var rW = void 0,
			    rH = void 0;
			var videoAspectRatio = vH / vW,
			    cntAspectRatio = cntHeight / cntWidth;
			if (cntAspectRatio < videoAspectRatio) {
				rW = cntWidth;
				rH = cntWidth / vW * vH;
			} else {
				rH = cntHeight;
				rW = cntHeight / vH * vW;
			}

			el.style.width = rW + 'px';
			el.style.height = rH + 'px';
		}
	}
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_Helpers_js__ = __webpack_require__(10);
//
//
//
//
//
//


var defaultWidth = 1280,
    defaultWidthMobile = 640,
    defaultFont = 16,
    minWidth = 320,
    minHeight = 320,
    defaultHeight = 720;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Resize',
  mounted: function mounted() {
    this.bodyEl = document.querySelector('html');
    window.addEventListener('resize', this.onResize.bind(this));
    if (__WEBPACK_IMPORTED_MODULE_0__tools_Helpers_js__["a" /* default */].isMobile() || __WEBPACK_IMPORTED_MODULE_0__tools_Helpers_js__["a" /* default */].isIPAD()) {
      this.bodyEl.classList.add('mobile');
    } else {
      this.bodyEl.classList.remove('mobile');
    }
  },
  data: function data() {
    return {
      vW: window.innerWidth,
      vH: window.innerHeight
    };
  },

  computed: {
    fSize: function fSize() {
      if (__WEBPACK_IMPORTED_MODULE_0__tools_Helpers_js__["a" /* default */].isMobile() || __WEBPACK_IMPORTED_MODULE_0__tools_Helpers_js__["a" /* default */].isIPAD()) {
        return defaultFont * Math.max(minWidth, this.vW) / defaultWidthMobile;
      } else {
        return defaultFont * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
      }
    }
  },
  methods: {
    onResize: function onResize() {
      this.vW = window.innerWidth;
      this.vH = window.innerHeight;
    }
  },
  components: {
    Helpers: __WEBPACK_IMPORTED_MODULE_0__tools_Helpers_js__["a" /* default */]
  }

});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Socials',
	data: function data() {
		return {
			Helpers: __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */],
			url: encodeURIComponent(window.location.protocol + '//' + window.location.host)
		};
	},

	components: {
		tw: __WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg___default.a,
		fb: __WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg___default.a,
		vk: __WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg___default.a,
		Helpers: __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */]
	},
	methods: {
		share: function share(sn) {
			var url = this.url;
			__WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */].ga().send('click', 'share ' + sn);
			__WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */].share(sn, url);
		}
	}
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Socials',
    components: {
        tw: __WEBPACK_IMPORTED_MODULE_0__assets_svg_tw_svg___default.a,
        fb: __WEBPACK_IMPORTED_MODULE_1__assets_svg_fb_svg___default.a,
        vk: __WEBPACK_IMPORTED_MODULE_2__assets_svg_vk_svg___default.a,
        Helpers: __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */]
    },
    methods: {
        socialAuth: function socialAuth(sn) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */].ga().send('click', 'Авторизация - ' + sn);
            this.$store.dispatch('socialAuth', sn).then(function () {
                _this.$store.commit('SET_POPUP', false);
            });
        }
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_down_svg__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_down_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_CoverContainer__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_CoverContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_CoverContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__landing_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__landing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__landing_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Index',
	components: {
		ArrowDown: __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_down_svg___default.a,
		Landing: __WEBPACK_IMPORTED_MODULE_5__landing_vue___default.a,
		CoverContainer: __WEBPACK_IMPORTED_MODULE_4__components_common_CoverContainer___default.a
	},
	data: function data() {
		return {
			showSkip: true,
			Helpers: __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */]
		};
	},

	methods: {
		skipVideo: function skipVideo() {},
		innerTLPlay: function innerTLPlay() {
			var _this = this;

			var self = this;
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {

				self.$store.commit('UPD_HANDLE_BLOCK', true);
				TweenMax.fromTo(_this.innerTL, _this.innerTL.duration(), { time: 0 }, {
					time: _this.innerTL.duration(), onComplete: function onComplete() {
						self.$store.commit('UPD_HANDLE_BLOCK', false);
						resolve();
					}
				});
			});
		},
		innerTLReverse: function innerTLReverse() {
			var _this2 = this;

			var self = this;
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {

				self.$store.commit('UPD_HANDLE_BLOCK', true);
				TweenMax.fromTo(_this2.innerTL, _this2.innerTL.duration(), { time: _this2.innerTL.duration() }, {
					time: 0, onComplete: function onComplete() {
						self.$store.commit('UPD_HANDLE_BLOCK', false);
						resolve();
						self.$store.commit('UPD_ANIMATED', true);
					}
				});
			});
		},
		forceShow: function forceShow() {
			var _this3 = this;

			this.startTL.progress(1);
			setTimeout(function () {
				_this3.$store.commit('UPD_ANIMATED', true);
			}, 500);
			this.showSkip = false;
		},
		toLanding: function toLanding() {
			if (this.animateEnded) {
				this.$router.push('/rules');
			}
		}
	},

	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		this.innerTLPlay().then(function () {
			next();
		});
	},

	mounted: function mounted() {
		var _this4 = this;

		var self = this;
		this.Helpers.ga().send('load', 'Главная страница');
		var logo = this.$refs.logo;
		var title = this.$refs.title;
		var text = this.$refs.text;
		var arrow = this.$refs.arrow;
		var overlay = this.$refs.overlay;
		var lines1 = this.$refs.lines1;
		var lines2 = this.$refs.lines2;
		var criroWrapper = this.$refs.criroWrapper ? this.$refs.criroWrapper : {};
		var circleWrapper = this.$refs.circleWrapper ? this.$refs.circleWrapper : {};

		var video = this.$refs.video;
		var videoPrev = this.$refs.videoPrev;

		this.innerTL = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({
			paused: true
		});

		this.innerTL.to(title, .5, { opacity: 0 }).to(text, .5, { opacity: 0 }, '-=.5').to(arrow, .5, { opacity: 0 }, '-=.5').to(lines1, .5, { x: '-100%', y: '100%' }).to(lines2, .5, { x: '-80%', y: '100%' }, '-=.5').to(overlay, .8, { opacity: 1 });
		this.startTL = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({
			paused: true,
			onComplete: function onComplete() {
				self.$store.commit('UPD_LOAD_ANIMATE', true);
			}
		});

		this.startTL.to(videoPrev, .5, { opacity: 0 }).from(logo, 1, { opacity: 0, delay: 5 }).from(lines1, .5, { x: '-100%', y: '100%' }).from(lines2, .5, { x: '-80%', y: '100%' }, '-=.5').from(overlay, .8, { opacity: 0 }, __WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */].isTouch() ? 5 : '-=0').to(logo, .5, { opacity: 0 }).from(circleWrapper, 1, { height: '0em' }).from(criroWrapper, 1, { height: '0em' }, '-=1').to(circleWrapper, 1, { height: '0em', delay: 1.5 }).to(criroWrapper, 1, { height: '0em' }, '-=1').from(title, .5, {
			y: '-100%', onComplete: function onComplete() {
				self.$store.commit('UPD_UI_SHOW', true);
				self.showSkip = false;
			}
		}).from(text, .5, { y: '-100%' }, '-=.2').from(arrow, .5, {
			opacity: 0,
			onComplete: function onComplete() {
				arrow.classList.add('animate');
				_this4.animateEnded = true;
			}
		});

		if (!this.$store.getters['GET_LOAD_ANIMATE']) {
			if (__WEBPACK_IMPORTED_MODULE_3__tools_Helpers__["a" /* default */].isTouch()) {
				this.startTL.progress(.4);
				this.startTL.play();
			} else {
				video.oncanplaythrough = function () {
					_this4.startTL.play();
				};
			}
		} else {
			this.startTL.progress(1);
			this.innerTLReverse();
		}
	}
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Product',
	props: ['canAnimate3'],
	data: function data() {
		return {
			Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
		};
	},

	components: {
		Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
	},
	computed: {
		showPage: function showPage() {
			return this.$route.name === 'Product';
		}
	}
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_awesome_swiper_src_swiper_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_awesome_swiper_src_swiper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_awesome_swiper_src_swiper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_awesome_swiper_src_slide_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_awesome_swiper_src_slide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_awesome_swiper_src_slide_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_star_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_clock_svg__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_cup_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_cup_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_svg_cup_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_slider_arrow_svg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_slider_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_svg_slider_arrow_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var weeks = [{
	name: 'первая неделя',
	id: 1
}, {
	name: 'вторая неделя',
	id: 2
}, {
	name: 'третья неделя',
	id: 3
}, {
	name: 'четвертая неделя',
	id: 4
}, {
	name: 'пятая неделя',
	id: 5
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		SwiperSlide: __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_awesome_swiper_src_slide_vue___default.a,
		Swiper: __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_awesome_swiper_src_swiper_vue___default.a,
		'svg-star': __WEBPACK_IMPORTED_MODULE_4__assets_svg_star_svg___default.a,
		'svg-clock': __WEBPACK_IMPORTED_MODULE_5__assets_svg_clock_svg___default.a,
		'svg-cup': __WEBPACK_IMPORTED_MODULE_6__assets_svg_cup_svg___default.a,
		arrow: __WEBPACK_IMPORTED_MODULE_7__assets_svg_slider_arrow_svg___default.a
	},
	name: 'Profile',
	data: function data() {
		return {
			videoInfo: {
				link: '',
				date: new Date()
			},
			Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */],
			weeks: weeks,
			testDone: true,
			hasVideo: false,
			noAvatar: '/static/img/profile/no-ava.png',
			swiperOptions: {
				autoplay: false,
				prevButton: '.swiper-button-prev',
				nextButton: '.swiper-button-next'
			}
		};
	},
	mounted: function mounted() {
		this.$store.commit('UPD_UI_SHOW', true);
		this.$store.commit('SET_POPUP', { name: false });
		this.userRating[0].link && this.userRating[0].week == this.currentWeek ? this.hasVideo = true : this.hasVideo = false;
	},

	computed: {
		currentWeek: function currentWeek() {
			return this.$store.getters['getCurrentWeek'];
		},
		user: function user() {
			return this.$store.getters['getUserData'];
		},
		userRating: function userRating() {
			return this.$store.getters['getUserRatingList'];
		}
	},
	methods: {
		sendVideo: function sendVideo() {
			var _this = this;

			if (!/^(f|ht)tps?:\/\//i.test(this.videoInfo.link)) {
				this.videoInfo.link = "http://" + this.videoInfo.link;
			}

			this.$store.dispatch('postVideo', this.videoInfo).then(function () {
				_this.$store.commit('SET_POPUP', { name: 'Thank' });
				_this.hasVideo = true;
			});

			__WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('submit', 'Отправить видео', this.videoInfo.link);
		},
		getVideoPopup: function getVideoPopup() {
			this.$store.commit('SET_POPUP', { name: 'Info' });
		},
		getWeekData: function getWeekData(id) {
			if (this.userRating.length) {
				return this.userRating.filter(function (item) {
					return parseInt(item.week) === parseInt(id);
				})[0];
			} else {
				return false;
			}
		},
		toHHMMSS: function toHHMMSS(secs) {
			var sec_num = parseInt(secs, 10);
			var hours = Math.floor(sec_num / 3600) % 24;
			var minutes = Math.floor(sec_num / 60) % 60;
			var seconds = sec_num % 60;
			return [hours, minutes, seconds].map(function (v) {
				return v < 10 ? "0" + v : v;
			}).filter(function (v, i) {
				return v !== "00" || i > 0;
			}).join(":");
		}
	},
	created: function created() {}
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var weeks = [{
	name: 'первая <br>неделя',
	id: 1
}, {
	name: 'вторая <br>неделя',
	id: 2
}, {
	name: 'третья <br>неделя',
	id: 3
}, {
	name: 'четвертая <br>неделя',
	id: 4
}, {
	name: 'пятая <br>неделя',
	id: 5
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Rating',
	data: function data() {
		return {
			weeks: weeks,
			Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */],
			showInnerWeek: false
		};
	},

	computed: {
		currentWeek: function currentWeek() {
			return this.$store.getters['getCurrentWeek'];
		}
	},
	components: {
		Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
	},
	mounted: function mounted() {
		this.Helpers.ga().send('load', 'Страница рейтинга общего');
		this.$store.commit('UPD_UI_SHOW', true);
	},

	methods: {
		showWeek: function showWeek(e, path) {
			this.$router.push(path);

			//				if(Helpers.isMobile() ){
			//					this.$router.push(path)
			//				}else {
			//					let parent = e.currentTarget.parentNode;
			//					parent.classList.add('actived');
			//					this.showInnerWeek = true;
			//					setTimeout(() => {
			//						this.$router.push(path)
			//					},1500)
			//				}
		}
	}
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_star_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_clock_svg__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_cross_svg__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_cross_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_cross_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_cup_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_cup_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_cup_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var best = [];

var weeks = [{
	name: 'первая <br>неделя',
	id: 1
}, {
	name: 'вторая <br>неделя',
	id: 2
}, {
	name: 'третья <br>неделя',
	id: 3
}, {
	name: 'четвертая <br>неделя',
	id: 4
}, {
	name: 'пятая <br>неделя',
	id: 5
}];

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Rating',
	components: {
		star: __WEBPACK_IMPORTED_MODULE_1__assets_svg_star_svg___default.a,
		clock: __WEBPACK_IMPORTED_MODULE_2__assets_svg_clock_svg___default.a,
		'svg-cross': __WEBPACK_IMPORTED_MODULE_3__assets_svg_cross_svg___default.a,
		'svg-cup': __WEBPACK_IMPORTED_MODULE_4__assets_svg_cup_svg___default.a
	},
	data: function data() {
		return {
			i: 0,
			weeks: weeks,
			Helpers: __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__["a" /* default */]
		};
	},

	computed: {
		list: function list() {
			return this.$store.getters['getRatingList'];
		},
		week: function week() {
			var _this = this;

			return this.weeks.find(function (item) {
				return item.id === parseInt(_this.$route.params.id);
			});
		},
		currentWeek: function currentWeek() {
			return this.$store.getters['getCurrentWeek'] || 0;
		},
		weekWinner: function weekWinner() {
			//				return this.$route.params.id <= this.currentWeek ? this.$store.getters['getWinner'] : null;
			return this.$store.getters['getWinnerByWeek'](this.$route.params.id);
		},
		nextWeekIdx: function nextWeekIdx() {
			return parseInt(this.$route.params.id) + 1;
		},
		nextWeekActive: function nextWeekActive() {
			return parseInt(this.$route.params.id) < this.currentWeek;
		}
	},

	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		this.$store.dispatch('getRating', to.params.id).then(function () {
			next();
		}, function () {
			next('/rating');
		});
	},


	methods: {
		getWeekData: function getWeekData(id) {},
		toHHMMSS: function toHHMMSS(secs) {
			var sec_num = parseInt(secs, 10);
			var hours = Math.floor(sec_num / 3600) % 24;
			var minutes = Math.floor(sec_num / 60) % 60;
			var seconds = sec_num % 60;
			return [hours, minutes, seconds].map(function (v) {
				return v < 10 ? "0" + v : v;
			}).filter(function (v, i) {
				return v !== "00" || i > 0;
			}).join(":");
		}
	},
	mounted: function mounted() {
		this.Helpers.ga().send('load', 'Страница рейтинга недели');
		this.$store.commit('UPD_UI_SHOW', true);
	}
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'RatingLayout',
	computed: {}
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var navItems = [{
    text: 'Пройди тест<br>на&nbsp;знание<br>истории<br>игры FIFA',
    link: '/test',
    linkText: 'Пройти'
}, {
    text: 'Зарегистрируйся<br>и&nbsp;сохрани<br>свой результат',
    link: '/',
    linkText: 'Создать',
    popup: 'Auth'
}, {
    text: 'Пришли<br>видеоповтор<br>гола',
    link: '/'
    //            linkText: 'Прислать',
    //            popup: 'Info'
}, {
    text: 'Следи<br>за&nbsp;результатами<br>других<br>участников',
    link: '/rating',
    linkText: 'Следить'
}, {
    text: 'Смотри<br>видео-отчеты<br>об играх<br>в&nbsp;редакции',
    link: '/video',
    linkText: 'Посмотреть'
}, {
    text: 'Тренируйся<br>в&nbsp;FIFA 18<br>и&nbsp;стань чемпионом!',
    link: '/product',
    linkText: 'Потренироваться'
}];

var footballersItems = [{
    text: 'Георгий Джикия<br>16.11.2017',
    img: 'jk'
}, {
    text: 'Константин Кучаев<br>24.11.2017',
    img: 'kk'
}, {
    text: 'Дмитрий Сычев<br>27.11.2017',
    img: 'sch'
}, {
    text: 'Братья Миранчуки<br>28.11.2017',
    img: 'pr'
}, {
    text: 'Антон Шунин<br>05.12.2017',
    img: 'shn'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Rules',
    data: function data() {
        return {
            Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */],
            navItems: navItems,
            footballersItems: footballersItems,
            isFootballersAnimated: false,
            isTestAnimated: false
        };
    },


    computed: {
        currentWeek: function currentWeek() {
            return this.$store.getters['getCurrentWeek'];
        },
        user: function user() {
            return this.$store.getters['getUserData'];
        },
        isGuest: function isGuest() {
            return this.$store.getters['isGuest'];
        },
        userRating: function userRating() {
            return this.$store.getters['getUserRatingList'];
        }
    },

    methods: {
        sendEvent: function sendEvent(item) {
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('click', 'page Rules', item.linkText);
        },
        showVideoPopup: function showVideoPopup(name) {
            if (name === 'Auth' && !this.isGuest) {
                this.$router.push('/profile');
                return false;
            }
            this.$store.commit('SET_POPUP', { name: name });
        },
        isInViewport: function isInViewport(el) {
            var rect = el.getBoundingClientRect();
            var html = document.documentElement;
            return rect.top <= (window.innerHeight || html.clientHeight) * .3;
        },
        animateNav: function animateNav() {
            var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();
            var i = 0;
            var items = this.$refs.navItems;
            var overlay = this.$refs.overlay;

            tl.staggerTo('.rules-nav-item', .3, {
                opacity: 1, onComplete: function onComplete() {
                    items[i].classList.add('animate');
                    i++;
                }
            }, .4).to(overlay, 1, { opacity: 0, delay: .5 });
        },
        animateFootballers: function animateFootballers() {
            var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();
            var i = 0;
            var items = this.$refs.footballersItems;
            var title = this.$refs.title;

            tl.to(title, .3, { y: 0 }).staggerTo('.rules-footballers-item', .3, {
                opacity: 1, onComplete: function onComplete() {
                    items[i].classList.add('animate');
                    i++;
                }
            }, .4);
        },
        animateTest: function animateTest() {

            var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();
            var circleWrapper = this.$refs.circleWrapper;
            var testContent = this.$refs.testContent;
            tl.to(circleWrapper, 1, { height: '43.125em', delay: .5 }).to(testContent, 1, { height: '25em' }, '-=1');
        }
    },
    mounted: function mounted() {
        this.animateNav();
        this.animateFootballers();

        this.Helpers.ga().send('load', 'Страница правил');
    },

    components: {
        Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
    }

});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Test',
    props: ['canAnimate'],

    data: function data() {
        return {
            Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */],
            height: '',
            trgCenterPoint: 0
        };
    },

    computed: {
        showPage: function showPage() {
            return this.$route.name === 'Test';
        }
    },
    methods: {
        onResize: function onResize() {
            var _this = this;

            setTimeout(function () {
                var tHeight = parseInt(window.getComputedStyle(_this.$refs['testContent']).height);
                var tContentRect = _this.$refs['testContent'].getBoundingClientRect();
                var wContentRect = _this.$refs['wrapperContent'].getBoundingClientRect();
                var topPos = tContentRect.top - wContentRect.top;
                var bottomPos = wContentRect.bottom - tContentRect.bottom;

                var titleCenterPoint = topPos + tHeight / 2;
                var bottomPointDist = wContentRect.bottom - wContentRect.top;
                var topPointDist = titleCenterPoint - window.innerHeight / 2;

                if (topPos < bottomPos) {
                    return _this.height = bottomPointDist - topPointDist + 'px';
                }
                _this.height = window.innerHeight + 'px';
            }, 120);
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        window.addEventListener('resize', this.r = this.onResize.bind(this));
        setTimeout(function () {
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
            _this2.onResize();
        });
    },
    destroyed: function destroyed() {
        window.removeEventListener('resize', this.r);
    },

    components: {
        Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
    }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_star_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_star_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Test',
	data: function data() {
		return {
			Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */],
			questIndex: 0,
			points: 0,
			time: {
				min: 0,
				sec: 0
			}
		};
	},


	computed: {
		questions: function questions() {
			return this.$store.getters['GET_QUESTIONS'];
		}
	},

	mounted: function mounted() {
		var _this = this;

		this.$store.commit('SET_POPUP', {
			name: 'Attention',
			cb: function cb() {
				_this.$store.dispatch('START_TEST');
				_this.tick();
			}
		});
		this.Helpers.ga().send('load', 'Страница теста');
		this.$store.commit('UPD_UI_SHOW', true);
	},


	methods: {
		formatVal: function formatVal(val) {
			return parseInt(val) < 10 ? '0' + parseInt(val) : parseInt(val);
		},
		timer: function timer() {
			if (this.time.sec >= 59) {
				this.time.min += 1;
				this.time.sec = 0;
			} else {
				this.time.sec += 1;
			}
			this.tick();
		},
		tick: function tick() {
			this.timeout = setTimeout(this.timer, 1000);
		},
		resetTimer: function resetTimer() {
			this.time = {
				min: 0,
				sec: 0
			};
		},
		stopTimer: function stopTimer() {
			clearTimeout(this.timeout);
		},
		chooseAnswer: function chooseAnswer(questionId, answerId) {
			var self = this;

			var question = this.questions.find(function (item) {
				return item.id == questionId;
			});
			__WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('click', 'question', question.question);
			var answer = question.answers.find(function (item) {
				return item.id == answerId;
			});
			__WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('click', 'answer', answer.answer);
			this.stopTimer();

			this.$store.dispatch('SEND_ANSWER', answerId).then(function (response) {
				console.log(self.questIndex, self.questions.length);
				self.points += response.score;
				if (self.questIndex >= self.questions.length - 1) {
					self.completeTest();
				} else {
					self.questIndex += 1;
					self.resetTimer();
					self.tick();
				}
			});
		},
		completeTest: function completeTest() {
			var _this2 = this;

			this.$store.dispatch('END_TEST').then(function () {
				_this2.$router.push('/test/result');
			});
		}
	},
	components: {
		'starSvg': __WEBPACK_IMPORTED_MODULE_2__assets_svg_star_svg___default.a,
		Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
	}
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_tw_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_tw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_tw_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_vk_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_vk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_vk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Socials__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Socials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Socials__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TestResult',
    data: function data() {
        return {
            url: encodeURIComponent(window.location.protocol + '//' + window.location.host),
            Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
        };
    },

    computed: {
        testResult: function testResult() {
            return this.$store.getters['GET_TEST_RESULT'];
        },
        isGuest: function isGuest() {
            return this.$store.getters['isGuest'];
        }
    },
    created: function created() {
        if (!this.testResult) {
            this.$router.push('/test');
        }
    },

    methods: {
        authPopup: function authPopup() {
            this.$store.commit('SET_POPUP', { name: 'Auth' });
        },
        shareVideo: function shareVideo() {
            if (this.isGuest) {
                this.authPopup();
            } else {
                this.$router.push('/profile');
            }
        },
        formatVal: function formatVal(val) {
            return parseInt(val) < 10 ? '0' + parseInt(val) : parseInt(val);
        },
        share: function share(sn) {
            var url = this.url + '/share/1';
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].share(sn, url);
            __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('click', 'share test', sn);
        },
        socialAuth: function socialAuth(sn) {
            var _this = this;

            this.$store.dispatch('socialAuth', sn).then(function () {
                _this.$store.commit('SET_POPUP', false);
                _this.$router.push('/profile');
            });
        }
    },
    components: {
        tw: __WEBPACK_IMPORTED_MODULE_2__assets_svg_tw_svg___default.a,
        fb: __WEBPACK_IMPORTED_MODULE_3__assets_svg_fb_svg___default.a,
        vk: __WEBPACK_IMPORTED_MODULE_4__assets_svg_vk_svg___default.a,
        social: __WEBPACK_IMPORTED_MODULE_5__components_common_Socials___default.a
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_play_arrow_svg__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_play_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_play_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_slider_arrow_svg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_slider_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_svg_slider_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var weeks = [{
	closed: false,
	player: null,
	footballer: null,
	video: 'hvrklaZ-09A',
	preview: '/static/img/video/prev.jpg'
}, {
	closed: false,
	video: 'SVrKI0dTN9o',
	preview: '/static/img/video/prev2.jpg',
	player: null,
	footballer: null
}, {
	closed: false,
	video: '-2Dra9_Opuk',
	preview: '/static/img/video/prev3.jpg',
	player: null,
	footballer: null
}, {
	closed: false,
	video: 'CbLAOIkvb_8',
	preview: '/static/img/video/prev4.jpg',
	player: null,
	footballer: null
}, {
	closed: false,
	video: 'c2-UuEVZPSQ',
	preview: '/static/img/video/prev5.jpg',
	player: null,
	footballer: null
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Video',
	props: ['canAnimate2'],
	components: {
		play: __WEBPACK_IMPORTED_MODULE_0__assets_svg_play_arrow_svg___default.a,
		arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_slider_arrow_svg___default.a,
		Helpers: __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__["a" /* default */]
	},
	data: function data() {
		return {
			swiperOption: {
				slidesPerView: 'auto',
				prevButton: '.swiper-button-prev',
				nextButton: '.swiper-button-next',
				centeredSlides: true,
				loop: true,
				onInit: function onInit() {
					setTimeout(function () {
						var resizeEvent = window.document.createEvent('UIEvents');
						resizeEvent.initUIEvent('resize', true, false, window, 0);
						window.dispatchEvent(resizeEvent);
					}, 0);
				}
			},
			weeks: weeks,
			Helpers: __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__["a" /* default */]
		};
	},

	methods: {
		showVideo: function showVideo(videoId) {
			this.$store.commit('SET_POPUP', {
				name: 'Video',
				videoId: videoId
			});
		}
	},
	computed: {
		showPage: function showPage() {
			return this.$route.name === 'Video';
		}
	},
	mounted: function mounted() {
		//			setTimeout(()=> {
		//				this.$refs['mySwiper'].init();
		//			},100);
	}
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rules__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Test__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Test__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Video__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Product__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Index_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Landing',
	components: {
		Rules: __WEBPACK_IMPORTED_MODULE_0__Rules___default.a,
		Test: __WEBPACK_IMPORTED_MODULE_1__Test___default.a,
		VideoComponent: __WEBPACK_IMPORTED_MODULE_2__Video___default.a,
		Product: __WEBPACK_IMPORTED_MODULE_3__Product___default.a,
		Index: __WEBPACK_IMPORTED_MODULE_4__Index_vue___default.a,
		Helpers: __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__["a" /* default */]
	},
	data: function data() {
		return {
			Helpers: __WEBPACK_IMPORTED_MODULE_5__tools_Helpers__["a" /* default */],
			canTween: true,
			canAnimate: false,
			canAnimate2: false,
			canAnimate3: false
		};
	},

	watch: {
		'$route.name': function $routeName(name) {
			if (this.canTween) {
				this.tweenToPage(name);
			}
		}
	},
	computed: {
		routName: function routName() {
			return this.$route.name;
		}
	},
	methods: {
		onScroll: function onScroll(e) {
			var _this = this;

			var els = [document.getElementById('Rules'), document.getElementById('Test'), document.getElementById('Video'), document.getElementById('Product')];

			var nodes = els.filter(function (item) {
				return _this.isInViewport(item);
			});

			var delta = e.deltaY || e.detail || e.wheelDelta;
			var container = this.$refs['scrollContainer'];

			if (container.scrollTop === 0 && container.scrollTop < this.lastScrollTop) {
				if (els[0].getBoundingClientRect().top >= 0) {
					this.$router.push({ name: 'Index' });
				}
				return;
			}

			this.setActive(nodes, delta);

			this.lastScrollTop = container.scrollTop;
		},
		onMouseWheel: function onMouseWheel(e) {
			var _this2 = this;

			var delta = e.deltaY || e.detail || e.wheelDelta;

			var els = [document.getElementById('Rules'), document.getElementById('Test'), document.getElementById('Video'), document.getElementById('Product')];

			var nodes = els.filter(function (item) {
				return _this2.isRect(item);
			});

			if (document.getElementById('Test').getBoundingClientRect().top <= 450) {
				this.canAnimate = true;
			}
			if (document.getElementById('Video').getBoundingClientRect().top <= 250) {
				this.canAnimate2 = true;
			}
			if (document.getElementById('Product').getBoundingClientRect().top <= 250) {
				this.canAnimate3 = true;
			}
		},
		isRect: function isRect(el) {
			var rect = el.getBoundingClientRect();
			return rect.top <= 200;
		},
		isInViewport: function isInViewport(el) {
			var rect = el.getBoundingClientRect();
			var html = document.documentElement;
			return rect.top <= 0;
		},
		setActive: function setActive(items) {
			var _this3 = this;

			if (items.length) {
				this.canTween = false;
				var path = items[items.length - 1].id;
				this.$router.push({ name: path });

				this.$nextTick(function () {
					if (path === 'Video') {
						_this3.canAnimate2 = true;
					}
					if (path === 'Test') {
						_this3.canAnimate = true;
					}
					if (path === 'Product') {
						_this3.canAnimate3 = true;
					}
					_this3.canTween = true;
				});
			}
		},
		tweenToPage: function tweenToPage(name) {
			var self = this;
			var container = this.$refs['scrollContainer'];
			var rect = document.getElementById(name).getBoundingClientRect();

			this.canTween = false;

			TweenMax.to(container, .5, {
				scrollTop: container.scrollTop + rect.top + 1
			});
		}
	},
	mounted: function mounted() {
		var _this4 = this;

		//			this.$vuebar.destroyScrollbar(this.$refs['scrollBar']);
		this.$store.commit('UPD_UI_SHOW', true);
		this.canTween = true;
		setTimeout(function () {
			_this4.tweenToPage(_this4.routName);
		});
	}
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Socials__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Socials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Socials__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Footer',
	components: {
		Socials: __WEBPACK_IMPORTED_MODULE_0__components_common_Socials___default.a
	},
	computed: {
		animate: function animate() {
			return this.$store.getters['GET_UI_SHOW'];
		}
	}
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_fifa_headerlogo_svg__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_fifa_headerlogo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svg_fifa_headerlogo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_championat_logo_svg__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_championat_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_championat_logo_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Header',
	data: function data() {
		return {
			Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */],
			isToggle: false
		};
	},

	components: {
		Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */],
		fifalogo: __WEBPACK_IMPORTED_MODULE_2__assets_svg_fifa_headerlogo_svg___default.a,
		champlogo: __WEBPACK_IMPORTED_MODULE_3__assets_svg_championat_logo_svg___default.a
	},
	computed: {
		isGuest: function isGuest() {
			return this.$store.getters['isGuest'];
		},
		user: function user() {
			return this.$store.getters['getUserData'];
		},
		isProfilePage: function isProfilePage() {
			return this.$route.name === 'Profile';
		},
		animate: function animate() {
			return this.$store.getters['GET_UI_SHOW'];
		}
	},
	methods: {
		authPopup: function authPopup() {
			__WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('click', 'Авторизация - Войти');
			this.$store.commit('SET_POPUP', { name: 'Auth' });
		},
		logout: function logout() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('click', 'Авторизация - Выйти');
			this.$store.dispatch('logout').then(function () {
				if (_this.isProfilePage) _this.$router.push('/');
			}, function () {
				if (_this.isProfilePage) _this.$router.push('/');
			});
		},
		openMobileMenu: function openMobileMenu() {
			this.isToggle = !this.isToggle;
		},
		sendEvent: function sendEvent(eventName) {
			__WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */].ga().send('click', 'header ', eventName);
		}
	}
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Attention'
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_SocialsAuth__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_SocialsAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_SocialsAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'InfoWithBtn',
    components: {
        SocialsAuth: __WEBPACK_IMPORTED_MODULE_0__components_common_SocialsAuth___default.a
    },
    data: function data() {
        return {
            Helpers: __WEBPACK_IMPORTED_MODULE_1__tools_Helpers__["a" /* default */]
        };
    }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_close_svg__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Auth__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Attention__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Attention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Attention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Info__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Video__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Error__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Thank__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Thank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Thank__);
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BasePopup',
    components: {
        close: __WEBPACK_IMPORTED_MODULE_0__assets_svg_close_svg___default.a,
        Auth: __WEBPACK_IMPORTED_MODULE_1__Auth___default.a,
        Attention: __WEBPACK_IMPORTED_MODULE_2__Attention___default.a,
        Info: __WEBPACK_IMPORTED_MODULE_3__Info___default.a,
        Video: __WEBPACK_IMPORTED_MODULE_4__Video___default.a,
        Error: __WEBPACK_IMPORTED_MODULE_5__Error___default.a,
        Thank: __WEBPACK_IMPORTED_MODULE_6__Thank___default.a
    },
    computed: {
        popup: function popup() {
            return this.$store.getters['GET_POPUP'];
        },
        popupData: function popupData() {
            return this.$store.getters['GET_POPUP_DATA'];
        }
    },
    methods: {
        closePopup: function closePopup() {
            if (typeof this.popupData.cb === 'function') {
                this.popupData.cb();
            }
            this.$store.commit('SET_POPUP', { name: false });
        }
    }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Error',
    computed: {
        popupData: function popupData() {
            return this.$store.getters['GET_POPUP_DATA'];
        }
    }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Info',
	computed: {
		isGuest: function isGuest() {
			return this.$store.getters['isGuest'];
		}
	},
	methods: {
		closePopup: function closePopup() {
			this.$store.commit('SET_POPUP', { name: false });
		},
		showAuthPopup: function showAuthPopup() {
			var _this = this;

			this.$store.commit('SET_POPUP', { name: false });
			setTimeout(function () {
				_this.$store.commit('SET_POPUP', { name: 'Auth' });
			}, 800);
		}
	}
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Thank',
	methods: {
		closePopup: function closePopup() {
			this.$store.commit('SET_POPUP', { name: false });
		}
	}
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__ = __webpack_require__(10);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Video',
    data: function data() {
        return {
            Helpers: __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */],
            player: '',
            playerVars: {
                autoplay: 1,
                rel: 0,
                showinfo: 0
            }
        };
    },

    components: {
        Helpers: __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */]
    },
    computed: {
        videoData: function videoData() {
            return this.$store.getters['GET_POPUP_DATA'];
        }
    },
    methods: {
        playing: function playing() {}
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__tools_Helpers__["a" /* default */].ga().send('load', 'video : Отчёт с Джикия');
    }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Index__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Rules__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_Rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Test__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_Test__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_TestInner__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_TestInner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_TestInner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_TestResult__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_TestResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_TestResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Video__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Product__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_RatingLayout__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_RatingLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_RatingLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Rating__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_Rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_RatingInner__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_RatingInner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_RatingInner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Profile__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_Profile__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);















var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active-link',
    routes: [{
        path: '/',
        name: 'Index',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Index___default.a
    }, {
        path: '/rules',
        name: 'Rules',
        component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Rules___default.a
    }, {
        path: '/test',
        name: 'Test',
        component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Test___default.a

    }, {
        path: '/test/start',
        name: 'TestInner',
        component: __WEBPACK_IMPORTED_MODULE_6__components_pages_TestInner___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('GET_QUESTIONS').then(function () {
                next();
            }, function (error) {
                if (from.name !== null) {
                    next('/' + from.name);
                    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('SET_POPUP', {
                        name: 'Error',
                        title: 'Ошибка!',
                        text: error
                    });
                } else {
                    next('/');
                }
            });
        }
    }, {
        path: '/test/result',
        name: 'TestResult',
        component: __WEBPACK_IMPORTED_MODULE_7__components_pages_TestResult___default.a
    }, {
        path: '/video',
        name: 'Video',
        component: __WEBPACK_IMPORTED_MODULE_8__components_pages_Video___default.a
    }, {
        path: '/product',
        name: 'Product',
        component: __WEBPACK_IMPORTED_MODULE_9__components_pages_Product___default.a
    }, {
        path: '/rating',
        name: 'RatingLayout',
        component: __WEBPACK_IMPORTED_MODULE_10__components_pages_RatingLayout___default.a,
        children: [{
            path: '',
            name: 'Rating',
            component: __WEBPACK_IMPORTED_MODULE_11__components_pages_Rating___default.a
        }, {
            path: ':id',
            name: 'RatingInner',
            component: __WEBPACK_IMPORTED_MODULE_12__components_pages_RatingInner___default.a,
            beforeEnter: function beforeEnter(to, from, next) {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('getRating', to.params.id).then(function () {
                    next();
                }, function () {
                    next('/rating');
                });
            }
        }]
    }, {
        path: '/profile',
        name: 'Profile',
        component: __WEBPACK_IMPORTED_MODULE_13__components_pages_Profile___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].getters['isGuest']) {
                next('/');
            } else {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('getUserRating').then(function () {
                    next();
                });
            }
        }
    }]
});

/*
router.beforeEach((to, from, next) => {
	console.log('beforeEach::',to);
	next()

});*/

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CURRENT_ID", function() { return GET_CURRENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_LOAD_ANIMATE", function() { return GET_LOAD_ANIMATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_UI_SHOW", function() { return GET_UI_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_HANDLE", function() { return GET_HANDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_POPUP", function() { return GET_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_POPUP_DATA", function() { return GET_POPUP_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_URL_ROOT", function() { return GET_URL_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_QUEST", function() { return GET_QUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_ANIMATED", function() { return GET_ANIMATED; });

var GET_CURRENT_ID = function GET_CURRENT_ID(state) {
  return state.currentId;
};

var GET_LOAD_ANIMATE = function GET_LOAD_ANIMATE(state) {
  return state.animatedLoad;
};

var GET_UI_SHOW = function GET_UI_SHOW(state) {
  return state.uiShow;
};

var GET_HANDLE = function GET_HANDLE(state) {
  return state.handleBlock;
};

var GET_POPUP = function GET_POPUP(state) {
  return state.popup.name;
};

var GET_POPUP_DATA = function GET_POPUP_DATA(state) {
  return state.popup;
};

var GET_URL_ROOT = function GET_URL_ROOT(state) {
  return state.urlRoot;
};

var GET_QUEST = function GET_QUEST(state) {
  return state.quest;
};

var GET_ANIMATED = function GET_ANIMATED(state) {
  return state.animated;
};

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(61);



var URL_ROOT = '/api';
var GET_PARAM = '?' + Math.random();

var state = {
    questions: [],
    testResult: false
};

var actions = {
    GET_STATUS_TEST: function GET_STATUS_TEST(_ref) {
        var commit = _ref.commit,
            state = _ref.state,
            rootGetters = _ref.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/get' + GET_PARAM).then(function (response) {
                resolve();
            }, function (error) {
                reject(error.body.message);
            });
        });
    },
    GET_QUESTIONS: function GET_QUESTIONS(_ref2) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootGetters = _ref2.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/get' + GET_PARAM).then(function (response) {
                commit('CLEAR_QUESTIONS');
                commit('UPDATE_QUESTIONS', response.body);
                resolve();
            }, function (error) {
                reject(error.body.message);
            });
        });
    },
    START_TEST: function START_TEST(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state,
            rootGetters = _ref3.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/start').then(function () {
                resolve();
            }, function () {
                reject();
            });
        });
    },
    SEND_ANSWER: function SEND_ANSWER(_ref4, id) {
        var commit = _ref4.commit,
            state = _ref4.state,
            rootGetters = _ref4.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/answer?id=' + id).then(function (response) {
                resolve(response.body);
            }, function () {
                reject();
            });
        });
    },
    END_TEST: function END_TEST(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state,
            rootGetters = _ref5.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + URL_ROOT + '/test/end').then(function (response) {
                commit('UPDATE_TEST_RESULT', response.body);
                resolve(response.body);
            }, function () {
                reject();
            });
        });
    }
};

var getters = {

    GET_QUESTIONS: function GET_QUESTIONS(state) {
        return state.questions;
    },

    GET_TEST_RESULT: function GET_TEST_RESULT(state) {
        return state.testResult;
    }

};

var mutations = {
    UPDATE_QUESTIONS: function UPDATE_QUESTIONS(State, data) {
        State.questions = State.questions.concat(data);
    },
    UPDATE_TEST_RESULT: function UPDATE_TEST_RESULT(State, data) {
        var time = {
            min: parseInt(parseInt(data.data.time) / 60),
            sec: parseInt(parseInt(data.data.time) % 60)
        };
        State.testResult = {
            user_position: data.user_position,
            time: {
                min: time.min,
                sec: time.sec
            },
            score: data.data.score
        };
    },
    CLEAR_QUESTIONS: function CLEAR_QUESTIONS(State) {
        State.questions = [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: false,
    actions: actions,
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__ = __webpack_require__(10);




var BASE_URL = '/api';

var state = {
    userData: {},
    currentWeek: 0,
    ratingList: [],
    userRatingList: [],
    winners: []
};

var actions = {
    getUser: function getUser(_ref) {
        var dispatch = _ref.dispatch,
            commit = _ref.commit,
            getters = _ref.getters,
            rootGetters = _ref.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/user').then(function (response) {
                commit('updateUserData', response.body);
                resolve();
            }, function () {
                commit('clearAllData');
                reject();
            });
        });
    },
    getCurrentWeek: function getCurrentWeek(_ref2) {
        var dispatch = _ref2.dispatch,
            commit = _ref2.commit,
            getters = _ref2.getters,
            rootGetters = _ref2.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/test/current-week').then(function (response) {
                commit('updateWeek', response.body);
                resolve();
            }, function () {
                commit('updateWeek', 0);
                reject();
            });
        });
    },
    socialAuth: function socialAuth(_ref3, sn) {
        var dispatch = _ref3.dispatch,
            commit = _ref3.commit,
            getters = _ref3.getters,
            rootGetters = _ref3.rootGetters;

        var url = rootGetters['GET_URL_ROOT'] + sn;

        var screenX = typeof window.screenX !== 'undefined' ? window.screenX : window.screenLeft;
        var screenY = typeof window.screenY !== 'undefined' ? window.screenY : window.screenTop;
        var outerWidth = typeof window.outerWidth !== 'undefined' ? window.outerWidth : document.body.clientWidth;
        var outerHeight = typeof window.outerHeight !== 'undefined' ? window.outerHeight : document.body.clientHeight - 22;
        var width = 800;
        var height = 600;
        var left = parseInt(screenX + (outerWidth - width) / 2, 10);
        var top = parseInt(screenY + (outerHeight - height) / 2.5, 10);
        var features = 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var win = window.open(url, "_blank", features);

            var watch_timer = setInterval(function () {
                try {
                    if (win.closed) {
                        clearInterval(watch_timer);
                        dispatch('getUser').then(function () {
                            resolve();
                        }, function () {
                            reject();
                        });
                    }
                } catch (e) {
                    reject();
                }
            }, 200);
        });
    },
    logout: function logout(_ref4) {
        var dispatch = _ref4.dispatch,
            commit = _ref4.commit,
            getters = _ref4.getters,
            rootGetters = _ref4.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + '/auth/logout').then(function () {
                commit('clearAllData');
                resolve();
            }, function () {
                commit('clearAllData');
                resolve();
            });
        });
    },
    getRating: function getRating(_ref5, id) {
        var dispatch = _ref5.dispatch,
            commit = _ref5.commit,
            getters = _ref5.getters,
            rootGetters = _ref5.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/test-result?week=' + id + '&cache=' + __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__["a" /* default */].getRandomInt(0, 1000)).then(function (response) {
                commit('updateRatingList', response.body);
                commit('updateWinner', response.body);
                resolve();
            }, function () {
                reject();
            });
        });
    },
    postVideo: function postVideo(_ref6, data) {
        var dispatch = _ref6.dispatch,
            commit = _ref6.commit,
            getters = _ref6.getters,
            rootGetters = _ref6.rootGetters;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/user-repeat/save?link=' + data.link + '&date=' + data.date).then(function (response) {
                resolve();
            }, function () {
                reject();
            });
        });
    },
    getUserRating: function getUserRating(_ref7) {
        var dispatch = _ref7.dispatch,
            commit = _ref7.commit,
            getters = _ref7.getters,
            rootGetters = _ref7.rootGetters;

        console.log(getters['getUserId']);
        if (!getters['getUserId']) return;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/test-result' + '?cache=' + __WEBPACK_IMPORTED_MODULE_2__tools_Helpers__["a" /* default */].getRandomInt(0, 1000), {
                params: {
                    // week: getters['getCurrentWeek'],
                    user_id: getters['getUserId']
                }
            }).then(function (response) {
                commit('updateUserRatingList', response.body);
                resolve();
            }, function () {
                commit('clearAllData');
                reject();
            });
        });
    }
};

var getters = {
    getUserData: function getUserData(state) {
        return state.userData;
    },
    isGuest: function isGuest(state) {
        return typeof state.userData.id === 'undefined';
    },
    getCurrentWeek: function getCurrentWeek(state) {
        return state.currentWeek;
    },
    getRatingList: function getRatingList(state) {
        return state.ratingList;
    },
    getWinner: function getWinner(state) {
        return state.winner;
    },
    getUserId: function getUserId(state, getters) {
        return 'id' in getters.getUserData ? getters.getUserData.id : '';
    },
    getUserRatingList: function getUserRatingList(state) {
        return state.userRatingList;
    },
    getWinnerByWeek: function getWinnerByWeek(state, getters) {
        return function (id) {
            return state.winners.find(function (item) {
                return Number(item.week) === Number(id);
            });
        };
    }
};

var mutations = {
    updateUserData: function updateUserData(State, data) {
        State.userData = data;
    },
    clearAllData: function clearAllData(State) {
        State.userData = {};
    },
    updateWeek: function updateWeek(State, data) {
        State.currentWeek = data.weekNumber;
    },
    updateRatingList: function updateRatingList(State, data) {
        State.ratingList = data.items;
    },
    updateWinner: function updateWinner(State, data) {
        // State.winner = data.winners[Object.keys(data.winners)[0]];
        State.winners = data.winners;
    },
    updateUserRatingList: function updateUserRatingList(State, data) {
        State.userRatingList = data.items;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: false,
    actions: actions,
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ID", function() { return UPDATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPD_LOAD_ANIMATE", function() { return UPD_LOAD_ANIMATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPD_UI_SHOW", function() { return UPD_UI_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPD_ANIMATED", function() { return UPD_ANIMATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPD_HANDLE_BLOCK", function() { return UPD_HANDLE_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_POPUP", function() { return SET_POPUP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(121);


var UPDATE_ID = function UPDATE_ID(State, id) {
    State.currentId = parseInt(id);
};

var UPD_LOAD_ANIMATE = function UPD_LOAD_ANIMATE(State, animated) {
    State.animatedLoad = animated;
    State.handleBlock = !animated;
};

var UPD_UI_SHOW = function UPD_UI_SHOW(State, show) {
    State.uiShow = show;
};
var UPD_ANIMATED = function UPD_ANIMATED(State, animated) {
    State.animated = animated;
};

var UPD_HANDLE_BLOCK = function UPD_HANDLE_BLOCK(State, blockker) {
    State.handleBlock = blockker;
};

var SET_POPUP = function SET_POPUP(State, popup) {
    State.popup = popup ? popup : { name: false };
};

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dced5584",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(491),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(500),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(511),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(497),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(514),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cfd4948",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f76911da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(505),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(499),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(496),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(493),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(506),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      fontSize: _vm.fSize + 'px'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-rules"
  }, [_c('div', {
    staticClass: "rules-container"
  }, [_c('div', {
    staticClass: "bg-img"
  }), _vm._v(" "), _c('div', {
    ref: "overlay",
    staticClass: "page-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "rules-nav"
  }, [_c('ul', {
    staticClass: "rules-nav-list"
  }, _vm._l((_vm.navItems), function(item, key) {
    return _c('li', {
      ref: "navItems",
      refInFor: true,
      staticClass: "rules-nav-item animate-items",
      class: ("item-" + (key+1))
    }, [_c('div', {
      staticClass: "nav-icon-wrapper"
    }, [_c('div', {
      staticClass: "nav-icon animate-img",
      class: ("icon-" + (key+1)),
      style: (("background-image: url(static/img/rules/icons/" + (key + 1) + ".png)"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "nav-text-wrapper"
    }, [_c('h5', {
      staticClass: "text animate-text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "underline animate-line"
    }), _vm._v(" "), (item.popup) ? _c('a', {
      staticClass: "nav-item-link animate-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showVideoPopup(item.popup)
        }
      }
    }, [_vm._v(_vm._s(item.linkText))]) : _c('span', {
      on: {
        "click": function($event) {
          _vm.sendEvent(item)
        }
      }
    }, [_c('router-link', {
      staticClass: "nav-item-link animate-link",
      attrs: {
        "to": item.link
      }
    }, [_vm._v(" " + _vm._s(item.linkText))])], 1)])])
  })), _vm._v(" "), _c('a', {
    staticClass: "rules-link",
    attrs: {
      "href": "/static/rules/rules.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Полные правила")])]), _vm._v(" "), _c('div', {
    ref: "footballers",
    staticClass: "rules-footballers"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('h2', {
    ref: "title",
    staticClass: "title"
  }, [_vm._v("\n                    Футболисты,"), _c('br'), _vm._v("\n                    с которыми смогут сразиться"), _c('br'), _vm._v("\n                    победители конкурса\n                ")])]), _vm._v(" "), _c('ul', {
    staticClass: "rules-footballers-list"
  }, _vm._l((_vm.footballersItems), function(item, key) {
    return _c('li', {
      ref: "footballersItems",
      refInFor: true,
      staticClass: "rules-footballers-item animate-items",
      class: ("item-" + (key+1))
    }, [_c('div', {
      staticClass: "footballer-img-wrapper"
    }, [_c('div', {
      staticClass: "footballer-img animate-img",
      style: (("background-image: url(static/img/rules/footballers/" + (item.img) + ".png)"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "footballer-text-wrapper"
    }, [_c('h5', {
      staticClass: "footballer-text animate-text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "underline animate-line"
    })])])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popup__overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup__content",
    class: {
      video: this.popup === 'Video'
    }
  }, [_c('a', {
    staticClass: "popup__close",
    class: {
      info: this.popup === 'Info'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closePopup($event)
      }
    }
  }, [_c('close')], 1), _vm._v(" "), _c(_vm.popup, {
    tag: "component"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover-container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-auth"
  }, [_c('div', {
    staticClass: "popup-auth__content"
  }, [(!_vm.Helpers.isMobile()) ? _c('h3', {
    staticClass: "popup-auth__title popup__title"
  }, [_vm._v("\n            Авторизуйтесь через одну"), _c('br'), _vm._v("\n            из социальных сетей, чтобы войти:\n        ")]) : _c('h3', {
    staticClass: "popup-auth__title popup__title"
  }, [_vm._v("\n            Авторизуйтесь через"), _c('br'), _vm._v(" одну\n            из социальных сетей,"), _c('br'), _vm._v(" чтобы войти:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "popup-auth__socials"
  }, [_c('socials-auth')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [_c('div', {
    staticClass: "page page-rating"
  }, [_c('ul', {
    staticClass: "grid-lines-wrapper"
  }, [_c('li', {
    staticClass: "grid-line line-0"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-1"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-2"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-3"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-4"
  }), _vm._v(" "), _c('li', {
    staticClass: "grid-line line-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "text-wrapper"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("РЕЙТИНГ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "weeks-list",
    class: {
      collapse: _vm.showInnerWeek
    }
  }, _vm._l((_vm.weeks), function(item) {
    return _c('li', {
      staticClass: "weeks-item",
      class: {
        active: item.id <= _vm.currentWeek, current: item.id === _vm.currentWeek
      }
    }, [(item.id <= _vm.currentWeek) ? _c('a', {
      staticClass: "item-content item-link",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showWeek($event, ("/rating/" + (item.id)))
        }
      }
    }, [_c('div', {
      staticClass: "item-wrapper"
    }, [_c('h3', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])]) : _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-wrapper"
    }, [_c('h3', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:swipe.up",
      value: (_vm.toLanding),
      expression: "toLanding",
      arg: "swipe",
      modifiers: {
        "up": true
      }
    }],
    staticClass: "page page-index",
    attrs: {
      "id": "Index"
    },
    on: {
      "DOMMouseScroll": _vm.forceShow,
      "mousewheel": _vm.forceShow
    }
  }, [_c('div', {
    staticClass: "video-wrapper"
  }, [(!_vm.Helpers.isMobile()) ? _c('cover-container', [_c('video', {
    ref: "video",
    staticClass: "video",
    attrs: {
      "id": "video",
      "autoplay": "",
      "loop": "",
      "muted": "",
      "preload": "",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/video/fifa.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/static/video/fifa.mp4",
      "type": "video/mp4"
    }
  })])]) : _c('div', {
    staticClass: "video-poster"
  }), _vm._v(" "), _c('div', {
    ref: "videoPrev",
    staticClass: "video-preview",
    staticStyle: {
      "background-image": "url('/static/img/index/video-preview.gif')"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "overlay",
    staticClass: "page-overlay oh"
  }), _vm._v(" "), _c('div', {
    staticClass: "lines-wrapper"
  }, [_c('div', {
    ref: "lines1",
    staticClass: "lines1"
  }), _vm._v(" "), _c('div', {
    ref: "lines2",
    staticClass: "lines2"
  }), _vm._v(" "), (!_vm.$store.getters['GET_LOAD_ANIMATE']) ? _c('div', {
    ref: "circleWrapper",
    staticClass: "lines-circle-wrapper oh"
  }, [_c('div', {
    ref: "circle",
    staticClass: "lines-circle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "logo",
    staticClass: "logo"
  }), _vm._v(" "), (!_vm.$store.getters['GET_LOAD_ANIMATE']) ? _c('div', {
    ref: "criroWrapper",
    staticClass: "criro-wrapper oh"
  }, [_c('div', {
    ref: "criro",
    staticClass: "criro"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "title-wrapper oh"
  }, [_c('h1', {
    ref: "title",
    staticClass: "title"
  }, [_vm._v("встреча года")])]), _vm._v(" "), _c('div', {
    staticClass: "text-wrapper oh"
  }, [_c('p', {
    ref: "text",
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\tЛюбишь компьютерные игры серии FIFA? Мастерски создаешь непобедимые команды? Способен выиграть даже с дублем? Тогда докажи свои умения и окажись в числе тех счастливчиков, которых мы позовем в редакцию на матч в FIFA 18 против реального футболиста РФПЛ.\n\t\t\t")])]), _vm._v(" "), _c('div', {
    ref: "arrow",
    staticClass: "scroll-bottom",
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'Стрелка на главной')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/rules"
    }
  }, [_c('arrow-down')], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSkip),
      expression: "showSkip"
    }],
    staticClass: "skip",
    on: {
      "click": _vm.forceShow
    }
  }, [_vm._v("\n\t\t\tПропустить\n\t\t")])])])
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-attention"
  }, [_c('div', {
    staticClass: "popup-attention__content"
  }, [_c('h2', {
    staticClass: "popup-attention__title-big"
  }, [_vm._v("\n            Внимание!\n        ")]), _vm._v(" "), _c('h3', {
    staticClass: "popup-attention__title popup__title"
  }, [_vm._v("\n            Конкурс завершен, но вы все еще можете пройти этот увлекательный тест на знание истории компьютерной игры серии FIFA.\n        ")])])])
}]}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "socials-wrapper socials-auth"
  }, [_c('ul', {
    staticClass: "social-list"
  }, [_c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link fb",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.socialAuth('/auth/social/facebook');
      }
    }
  }, [_c('fb')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link vk",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.socialAuth('/auth/social/vkontakte');
      }
    }
  }, [_c('vk')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-product"
  }, [_c('transition', {
    attrs: {
      "name": "slideRight"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "footnote"
  }, [_vm._v("*Плейстейшн Про")])]), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "lines-wrapper oh"
  }, [_c('div', {
    staticClass: "lines"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('transition', {
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "title"
  }, [_vm._v("УЖЕ В ПРОДАЖЕ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideRight"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\tFIFA 18 на базе Frostbite™ стирает границы между виртуальным и реальным миром, досконально воссоздавая игроков, команды и атмосферу настоящего футбола.\n\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "product"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideDown"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate3),
      expression: "canAnimate3"
    }],
    staticClass: "btn",
    attrs: {
      "href": "https://www.easports.com/ru/fifa/buy/russia?utm_campaign=fifa18_hd_ru_scm_fixd_dcm&utm_medium=display&utm_source=championat_buy_sp&utm_content=banner&utm_term=c3",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'Купить Fifa');
      }
    }
  }, [_vm._v("\n\t\t\t\t\tКУПИТЬ\n\t\t\t\t")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-test",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    ref: "circleWrapper",
    staticClass: "lines-circle-wrapper"
  }, [_c('div', {
    ref: "circle",
    staticClass: "lines-circle"
  })])]), _vm._v(" "), _c('div', {
    ref: "wrapperContent",
    staticClass: "test-wrapper"
  }, [_c('div', {
    ref: "testContent",
    staticClass: "test-content"
  }, [_c('transition', {
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    staticClass: "title"
  }, [_vm._v("\n                    ПРОЙДИ ТЕСТ на знание fifa\n                ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideRight"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    staticClass: "text"
  }, [_vm._v("\n                    Ответь на 10 вопросов на время и поборись за приз — встречу\n                    с футболистом в офисе «Чемпионата». Тест обновляется\n                    каждую неделю.\n                ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideDown"
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate),
      expression: "canAnimate"
    }],
    staticClass: "btn",
    attrs: {
      "to": "/test/start"
    },
    nativeOn: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'Пройти тест')
      }
    }
  }, [_vm._v("ПРОЙТИ")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    ref: "scrollBar",
    staticClass: "landing"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "landing-scroll-cnt",
    on: {
      "scroll": _vm.onScroll,
      "mousewheel": _vm.onMouseWheel
    }
  }, [_c('div', {
    staticClass: "landing-bg"
  }, [_c('Rules', {
    attrs: {
      "id": "Rules"
    }
  }), _vm._v(" "), _c('Test', {
    attrs: {
      "id": "Test",
      "canAnimate": _vm.canAnimate
    }
  })], 1), _vm._v(" "), _c('VideoComponent', {
    attrs: {
      "id": "Video",
      "canAnimate2": _vm.canAnimate2
    }
  }), _vm._v(" "), _c('Product', {
    attrs: {
      "id": "Product",
      "canAnimate3": _vm.canAnimate3
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "footer-container"
  }, [(_vm.$route.name === 'Index') ? _c('p', {
    staticClass: "special"
  }, [_vm._v("Специальный проект")]) : _vm._e(), _vm._v(" "), _c('socials')], 1)])
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-video"
  }, [_c('youtube', {
    ref: "youtube",
    staticClass: "video-youtube",
    attrs: {
      "video-id": _vm.videoData.videoId,
      "player-vars": _vm.playerVars
    },
    on: {
      "playing": _vm.playing
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name !== 'TestResult' && _vm.$route.name !== 'TestInner') ? _c('div', {
    staticClass: "socials-wrapper"
  }, [_c('ul', {
    staticClass: "social-list"
  }, [_c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link tw",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('tw')
      }
    }
  }, [_c('tw')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link fb",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('fb')
      }
    }
  }, [_c('fb')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link vk",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('vk')
      }
    }
  }, [_c('vk')], 1)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-video"
  }, [_c('div', {
    ref: "overlay",
    staticClass: "page-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "lines-wrapper"
  }, [_c('div', {
    ref: "lines1",
    staticClass: "lines1"
  }), _vm._v(" "), _c('div', {
    ref: "lines2",
    staticClass: "lines2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate2),
      expression: "canAnimate2"
    }],
    staticClass: "title"
  }, [_vm._v("Смотри видеоотчеты")])])], 1), _vm._v(" "), (!_vm.Helpers.isTouch()) ? _c('ul', {
    staticClass: "video-list"
  }, _vm._l((_vm.weeks), function(item, key) {
    return _c('li', {
      staticClass: "video-item",
      class: {
        disabled: item.closed
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "video-preview",
      style: (("background-image: url(" + (item.closed ? '/static/img/video/lock.png' : item.preview) + ")"))
    }, [(!item.closed) ? _c('a', {
      staticClass: "play",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showVideo(item.video)
        }
      }
    }, [_c('play')], 1) : _vm._e()]), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "player",
      style: (("background-image: url(" + (item.player) + ")"))
    }) : _vm._e(), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "footballer",
      style: (("background-image: url(" + (item.footballer) + ")"))
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('h6', {
      staticClass: "text"
    }, [_vm._v(_vm._s(key + 1) + " неделя")])])])
  })) : _c('swiper', {
    ref: "mySwiper",
    staticClass: "video-list",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('arrow')], 1), _vm._v(" "), _vm._l((_vm.weeks), function(item, key) {
    return _c('swiper-slide', {
      key: key,
      class: {
        disabled: item.closed
      }
    }, [_c('div', {
      staticClass: "video-item"
    }, [_c('div', {
      staticClass: "item-content"
    }, [_vm._v("`\n\t\t\t\t\t\t"), _c('div', {
      staticClass: "video-preview",
      style: (("background-image: url(" + (item.closed ? '/static/img/video/lock.png' : item.preview) + ")"))
    }, [(!item.closed) ? _c('a', {
      staticClass: "play",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showVideo(item.video)
        }
      }
    }, [_c('play')], 1) : _vm._e()]), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "player",
      style: (("background-image: url(" + (item.player) + ")"))
    }) : _vm._e(), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "footballer",
      style: (("background-image: url(" + (item.footballer) + ")"))
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('h6', {
      staticClass: "text"
    }, [_vm._v(_vm._s(key + 1) + " неделя")])])])])
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-test page-testresult"
  }, [_c('div', {
    staticClass: "result__item"
  }, [_c('div', {
    staticClass: "result__item-leftside"
  }, [_c('router-link', {
    attrs: {
      "to": "/rating"
    }
  }, [_vm._v("\n                " + _vm._s(!_vm.Helpers.isTouch() ? 'Посмотреть рейтинг' : 'Рейтинг') + "\n            ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n                На главную\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "result__item-content"
  }, [_c('div', {
    staticClass: "content-main"
  }, [_vm._v("\n                вы прошли тест за "), _c('span', {
    staticClass: "minutes"
  }, [_vm._v(_vm._s(_vm.formatVal(_vm.testResult.time.min)) + ":" + _vm._s(_vm.formatVal(_vm.testResult.time.sec)))]), _vm._v(" минут"), _c('br'), _vm._v("\n                и набрали "), _c('span', {
    staticClass: "balls"
  }, [_vm._v(_vm._s(_vm.testResult.score))]), _vm._v(" баллов."), _c('br', {
    staticClass: "mobile"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-social"
  }, [_c('div', {
    staticClass: "content-social__text"
  }, [_vm._v("\n                    Поделитесь результатом:\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "social-list"
  }, [_c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link tw",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('tw')
      }
    }
  }, [_c('tw')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link fb",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('fb')
      }
    }
  }, [_c('fb')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link vk",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.share('vk')
      }
    }
  }, [_c('vk')], 1)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-profile"
  }, [_vm._m(0), _vm._v(" "), (!_vm.Helpers.isTouch()) ? _c('ul', {
    staticClass: "weeks-list"
  }, _vm._l((_vm.weeks), function(item) {
    return _c('li', {
      staticClass: "weeks-item",
      class: {
        active: item.id <= _vm.currentWeek, current: item.id === _vm.currentWeek
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [((item.id <= _vm.currentWeek) && (_vm.getWeekData(item.id))) ? _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('div', {
      staticClass: "cup-icon"
    }, [_c('svg-cup')], 1), _vm._v(" "), _c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item-info__place"
    }, [_vm._v(_vm._s(_vm.getWeekData(item.id).position) + " место")]), _vm._v(" "), _c('div', {
      staticClass: "item-info__bottom-group"
    }, [_c('div', {
      staticClass: "item-info__time-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.toHHMMSS(_vm.getWeekData(item.id).time)) + "\n\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__time-group-icon"
    }, [_c('svg-clock')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "item-info__divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info__favorites-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getWeekData(item.id).score) + "\n\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__favorites-group-icon"
    }, [_c('svg-star')], 1)])]), _vm._v(" "), (_vm.getWeekData(item.id).link) ? _c('div', {
      staticClass: "item-info__video-replay"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.getWeekData(item.id).link
      }
    }, [_vm._v("+ видеоповтор")])]) : _vm._e()])]) : _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])])])
  })) : _c('swiper', {
    staticClass: "weeks-list slider",
    attrs: {
      "options": this.swiperOptions
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('arrow')], 1), _vm._v(" "), _vm._l((_vm.weeks), function(item) {
    return _c('swiper-slide', {
      key: item.id,
      staticClass: "weeks-item",
      class: {
        active: item.id <= _vm.currentWeek, current: item.id === _vm.currentWeek
      }
    }, [_c('div', {
      staticClass: "item-content-wrapper"
    }, [_c('div', {
      staticClass: "item-content"
    }, [((item.id <= _vm.currentWeek) && (_vm.getWeekData(item.id))) ? _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('div', {
      staticClass: "cup-icon"
    }, [_c('svg-cup')], 1), _vm._v(" "), _c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item-info__place"
    }, [_vm._v(_vm._s(_vm.getWeekData(item.id).position) + " место")]), _vm._v(" "), _c('div', {
      staticClass: "item-info__bottom-group"
    }, [_c('div', {
      staticClass: "item-info__time-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.toHHMMSS(_vm.getWeekData(item.id).time)) + "\n\t\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__time-group-icon"
    }, [_c('svg-clock')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "item-info__divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info__favorites-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getWeekData(item.id).score) + "\n\t\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__favorites-group-icon"
    }, [_c('svg-star')], 1)])]), _vm._v(" "), (_vm.getWeekData(item.id).link) ? _c('div', {
      staticClass: "item-info__video-replay"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.getWeekData(item.id).link
      }
    }, [_vm._v("+ видеоповтор")])]) : _vm._e()])]) : _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "user-block"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('div', {
    staticClass: "user-avatar",
    style: (("background-image: url(" + (_vm.user.image_link ? _vm.user.image_link : _vm.noAvatar) + ")"))
  }), _vm._v(" "), _c('h1', {
    staticClass: "title user-name"
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('div', {
    staticClass: "text-wrapper"
  }, [(!_vm.userRating.length) ? _c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\tПройди тест и загрузи "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getVideoPopup($event)
      }
    }
  }, [_vm._v("видеоповтор")]), _vm._v(", чтобы попасть в общий рейтинг\n\t\t\t\t\t"), _c('router-link', {
    attrs: {
      "to": "/test/start"
    }
  }, [_vm._v("пройди тест")])], 1) : _c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\tСпасибо! Результат сохранен, можно улучшить свою позицию в рейтинге, загрузив "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getVideoPopup($event)
      }
    }
  }, [_vm._v("видеоповтор")]), _vm._v(".\n\t\t\t\t")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lines-wrapper"
  }, [_c('div', {
    staticClass: "lines-circle"
  })])
}]}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-info"
  }, [_c('div', {
    staticClass: "popup-info__content"
  }, [_c('h3', {
    staticClass: "popup-info__title popup__title"
  }, [_vm._v("\n\t\t\tСПАСИБО, ВАШЕ ВИДЕО"), _c('br'), _vm._v(" ОТПРАВЛЕНО НА МОДЕРАЦИЮ.\n\t\t")])])])
}]}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-info"
  }, [_c('div', {
    staticClass: "popup-info__content"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isGuest) ? _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("ДАЛЕЕ")]) : _c('a', {
    staticClass: "btn guest",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showAuthPopup
    }
  }, [_vm._v("Авторизоваться")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "popup-info__title popup__title"
  }, [_vm._v("\n\t\t\t1. ПОВТОРИ В FIFA 18 ЛЮБОЙ ЗНАМЕНИТЫЙ ГОЛ"), _c('br'), _vm._v(" ИЗ ФУТБОЛЬНОЙ ИСТОРИИ"), _c('br'), _vm._v("\n\t\t\t2. ПРИШЛИ НАМ ССЫЛКУ НА ВИДЕО"), _c('br'), _vm._v("\n\t\t\t3. И НЕ ЗАБУДЬ УКАЗАТЬ КОМАНДЫ И ДАТУ ЭТОГО МАТЧА.\n\t\t")])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [_c('div', {
    staticClass: "page page-rating-inner"
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-bg"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/rating"
    }
  }, [_vm._v("назад")]), _vm._v(" "), _c('div', {
    staticClass: "week-name-wrapper"
  }, [_c('div', {
    staticClass: "week-name"
  }, [_c('h3', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.week.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])]), _vm._v(" "), (_vm.weekWinner) ? _c('div', {
    staticClass: "best-of-week"
  }, [_c('div', {
    staticClass: "best-of-week__inner"
  }, [(!_vm.Helpers.isTouch()) ? _c('div', {
    staticClass: "best-of-week__cup-image"
  }, [_c('svg-cup')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "best-of-week__winner"
  }, [('user' in _vm.weekWinner) ? _c('div', {
    staticClass: "players-item"
  }, [(_vm.Helpers.isTouch()) ? _c('div', {
    staticClass: "best-of-week__cup-image"
  }, [_c('svg-cup')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "best-of-week__winner-header"
  }, [_vm._v("Победитель недели")]), _vm._v(" "), _c('div', {
    staticClass: "player-left"
  }, [_c('div', {
    staticClass: "player-avatar",
    style: ('image_link' in _vm.weekWinner.user ? ("background-image: url(" + (_vm.weekWinner.user.image_link) + ")") : '')
  })]), _vm._v(" "), _c('div', {
    staticClass: "player-right"
  }, [_c('p', {
    staticClass: "player-name"
  }, [_vm._v(_vm._s(_vm.weekWinner.user.first_name) + " " + _vm._s(_vm.weekWinner.user.last_name))]), _vm._v(" "), _c('div', {
    staticClass: "player-data"
  }, [(_vm.weekWinner.result) ? _c('div', {
    staticClass: "player-time"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.toHHMMSS(_vm.weekWinner.result.time)))]), _c('span', {
    staticClass: "icon"
  }, [_c('clock')], 1)]) : _vm._e(), _vm._v(" "), (_vm.weekWinner.result) ? _c('div', {
    staticClass: "player-points"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.weekWinner.result.score))]), _c('span', {
    staticClass: "icon"
  }, [_c('star')], 1)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "best-of-week__cross"
  }, [_c('svg-cross')], 1), _vm._v(" "), _c('div', {
    staticClass: "players-item"
  }, [_c('div', {
    staticClass: "best-of-week__winner-header"
  }, [_vm._v("Футболист недели")]), _vm._v(" "), _c('div', {
    staticClass: "player-left"
  }, [_c('div', {
    staticClass: "player-avatar",
    style: (("background-image: url(" + (_vm.weekWinner.player_photo) + ")"))
  })]), _vm._v(" "), _c('div', {
    staticClass: "player-right"
  }, [_c('p', {
    staticClass: "player-name"
  }, [_vm._v(_vm._s(_vm.weekWinner.player_name))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "players-scroll-wrapper",
    class: {
      fixedHeight: _vm.list.length >= 15
    }
  }, [_c('div', {
    staticClass: "players-scroll"
  }, [_c('ul', {
    staticClass: "players-list"
  }, _vm._l((_vm.list), function(item, key) {
    return _c('li', {
      staticClass: "players-item"
    }, [_c('div', {
      staticClass: "player-left"
    }, [_c('div', {
      staticClass: "player-position"
    }, [_vm._v(_vm._s(item.position))]), _vm._v(" "), (item.image_link) ? _c('div', {
      staticClass: "player-avatar",
      style: (("background-image: url(" + (item.image_link) + ")"))
    }) : _c('div', {
      staticClass: "player-avatar"
    })]), _vm._v(" "), _c('div', {
      staticClass: "player-right"
    }, [_c('p', {
      staticClass: "player-name"
    }, [_vm._v(_vm._s(item.first_name) + " " + _vm._s(item.last_name))]), _vm._v(" "), _c('div', {
      staticClass: "player-data"
    }, [_c('div', {
      staticClass: "player-time"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.toHHMMSS(item.time)))]), _c('span', {
      staticClass: "icon"
    }, [_c('clock')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "player-points"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.score))]), _c('span', {
      staticClass: "icon"
    }, [_c('star')], 1)]), _vm._v(" "), (item.link) ? _c('div', {
      staticClass: "player-videolink"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link
      }
    }, [_vm._v("+ видеоповтор")])]) : _vm._e()])])])
  }))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link link-next-week",
    class: {
      active: _vm.nextWeekActive
    },
    attrs: {
      "to": '/rating/' + _vm.nextWeekIdx
    }
  }, [(_vm.weeks[_vm.nextWeekIdx - 1] !== undefined) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.weeks[_vm.nextWeekIdx - 1].name)
    }
  }) : _vm._e()])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    staticClass: "app-layout",
    attrs: {
      "id": "app"
    }
  }, [_c('header-component'), _vm._v(" "), (_vm.Helpers.isTouch()) ? _c('div', {
    staticClass: "mobileWrapper"
  }, [(_vm.isLandingPage) ? _c('landing') : _c('router-view')], 1) : _c('div', {
    staticClass: "deskWrapper"
  }, [(_vm.isLandingPage) ? _c('landing') : _c('div', {
    staticClass: "pages-wrapper",
    on: {
      "DOMMouseScroll": _vm.onMouseWheel,
      "mousewheel": _vm.onMouseWheel
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('footer-component'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "show-popup",
      "appear": ""
    }
  }, [(_vm.popup) ? _c('base-popup') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-attention"
  }, [_c('div', {
    staticClass: "popup-attention__content"
  }, [_c('h2', {
    staticClass: "popup-attention__title-big",
    domProps: {
      "innerHTML": _vm._s(_vm.popupData.title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "popup-attention__title popup__title",
    domProps: {
      "innerHTML": _vm._s(_vm.popupData.text)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-container"
  }, [(_vm.$route.name !== 'Product') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "logo-wrapper"
  }, [_c('a', {
    staticClass: "champ-logo",
    attrs: {
      "href": "https://www.championat.com/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'championat-logo')
      }
    }
  }, [_c('champlogo')], 1), _vm._v(" "), _c('a', {
    staticClass: "fifa-logo",
    attrs: {
      "target": "_blank",
      "href": "https://www.easports.com/ru/fifa/buy/russia?utm_campaign=fifa18_hd_ru_scm_fixd_dcm&utm_medium=display&utm_source=championat_logo_sp&utm_content=banner&utm_term=c3"
    },
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'fifa-logo')
      }
    }
  }, [_c('fifalogo')], 1)]) : _vm._e(), _vm._v(" "), (_vm.Helpers.isMobile() || _vm.Helpers.isTouch()) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "burger",
    class: {
      open: _vm.isToggle
    },
    on: {
      "click": _vm.openMobileMenu
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "nav",
    class: {
      open: _vm.isToggle
    }
  }, [_c('ul', {
    staticClass: "nav-list"
  }, [_c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('О проекте')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link index",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("О проекте")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Правила')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/rules"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("Правила")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Тест')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/test"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("Тест")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Видеоотчеты')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/video"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("Видеоотчеты")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('FIFA 18')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/product"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("FIFA 18")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Рейтинг')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/rating"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("рейтинг")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item nav-user-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Авторизация')
      }
    }
  }, [(_vm.isGuest) ? _c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.authPopup($event)
      }
    }
  }, [_vm._v("Войти")]) : _c('div', {
    staticClass: "user-link"
  }, [_c('router-link', {
    staticClass: "nav-link user",
    attrs: {
      "to": "/profile",
      "href": "#"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.first_name))]), _vm._v(" "), _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("X")])], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-testInner page-test"
  }, [_c('transition-group', {
    attrs: {
      "name": "fadeIn",
      "appear": ""
    }
  }, _vm._l((_vm.questions), function(quest, num) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.questIndex === num),
        expression: "questIndex === num"
      }],
      key: num,
      staticClass: "quest_item"
    }, [_c('div', {
      staticClass: "lines-wrapper"
    }, [_c('div', {
      ref: "lines1",
      refInFor: true,
      staticClass: "lines1"
    }), _vm._v(" "), _c('div', {
      ref: "lines2",
      refInFor: true,
      staticClass: "lines2"
    })]), _vm._v(" "), _c('div', {
      staticClass: "quest_inner"
    }, [_c('div', {
      staticClass: "quest_head"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.formatVal(_vm.time.min)) + ":" + _vm._s(_vm.formatVal(_vm.time.sec)))])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('p', {
      staticClass: "points"
    }, [_vm._v(_vm._s(_vm.points) + "\n\t\t\t\t\t\t\t"), _c('starSvg', {
      staticClass: "star"
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "quest_body"
    }, [_c('p', {
      staticClass: "progress"
    }, [_vm._v(_vm._s((num + 1)))]), _vm._v(" "), _c('p', {
      staticClass: "question"
    }, [_vm._v(_vm._s(quest.question))]), _vm._v(" "), (!!quest.image) ? _c('img', {
      attrs: {
        "src": _vm.$store.getters['GET_URL_ROOT'] + quest.image,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "quest_footer"
    }, _vm._l((quest.answers), function(answer, index) {
      return _c('label', {
        key: index,
        staticClass: "radio_lbl"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'quest' + (num + 1)
        },
        on: {
          "change": function($event) {
            _vm.chooseAnswer(quest.id, answer.id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "mark"
      }), _vm._v(" "), _c('p', {
        staticClass: "text"
      }, [_vm._v(_vm._s(answer.answer))])])
    }))])])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 305.1 487"><path d="M301.2 324.9c-5.3-5.3-13.8-5.3-19.1 0l-116 116V13.5c0-7.5-6-13.5-13.5-13.5s-13.5 6-13.5 13.5v427.4l-116-116c-5.3-5.3-13.8-5.3-19.1 0-5.3 5.3-5.3 13.8 0 19.1l139 139c2.5 2.5 6 4 9.5 4s7-1.4 9.5-4l139-139c5.4-5.2 5.4-13.8.2-19.1z"/></svg>'};

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = {template: '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.666 51.934"><defs><clipPath id="a"><path fill="none" d="M0 0h41.666v51.934H0z"/></clipPath></defs><title>championat-logo</title><g clip-path="url(#a)"><path d="M12.49 31.97h6.877v12.626c-3.76-1.558-8.453-4.459-11.035-8.149-.85-1.214-1.826-3.179-1.826-7.639.918 1.967 3.351 3.162 5.984 3.162m1.832-3.261h5.86a3.568 3.568 0 0 0 2.443-.816v16.565c3.701-1.588 8.199-4.426 10.709-8.01.85-1.215 1.826-3.18 1.826-7.64V6.507H22.625v13.067a1.197 1.197 0 0 1-1.305 1.306h-2.277a1.195 1.195 0 0 1-1.303-1.306V6.507H6.506V20.88c0 4.673.506 7.829 7.816 7.829M3.234 3.233v25.575c0 4.193.746 7.129 2.416 9.516 3.801 5.434 10.995 9.035 15.184 10.261 4.187-1.226 11.381-4.827 15.182-10.26 1.671-2.388 2.416-5.324 2.416-9.517V3.233H3.234zM41.666 0v28.808c0 4.878-.943 8.433-3.002 11.372-4.484 6.409-12.873 10.546-17.83 11.754-4.959-1.208-13.348-5.345-17.832-11.754C.945 37.241 0 33.686 0 28.808V0h41.666z" fill="#fff"/></g></svg>'};

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path class="st0" d="M28.9 31.8L.6 60.1c-.8.8-.8 2.1 0 2.8.4.5.9.7 1.4.7.5 0 1-.2 1.4-.6L32 34.4 60.5 63c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2.1 0-2.8L35.1 31.8 63.4 3.4c.8-.8.8-2.1 0-2.8-.8-.8-2.1-.8-2.8 0L32 29.2 3.4.6C2.6-.2 1.3-.2.6.6c-.8.8-.8 2.1 0 2.8l28.3 28.4z"/></svg>'};

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 428.8 428.8"><path class="st0" fill="#fff" stroke="#fff" stroke-width="20" stroke-miterlimit="10" d="M7.1 7.1l414.6 414.6"/><path class="st1" fill="none" stroke="#fff" stroke-width="20" stroke-miterlimit="10" d="M421.7 7.1L7.1 421.7"/></svg>'};

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 211.4662 55.635"><defs><clipPath id="c" transform="translate(-.041 -.02)"><path d="M117.512 13.514a6.127 6.127 0 0 0-6.295 6.295v22.345h6.904v-21.33a1.574 1.574 0 0 1 1.627-1.625h1.622a1.475 1.475 0 0 1 1.628 1.625v5.89h-3.654v5.687h3.654v9.752h6.904V19.809a6.127 6.127 0 0 0-6.297-6.295h-6.093z" fill="none"/></clipPath><linearGradient id="a" y1="76.629" x2="1" y2="76.629" gradientTransform="matrix(0 -28.64 28.64 0 -2074.15 42.132)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#dee0ec"/><stop offset=".61" stop-color="#f6f6fa"/><stop offset="1" stop-color="#fff"/></linearGradient><clipPath id="d" transform="translate(-.041 -.02)"><path d="M97.642 13.514a6.17 6.17 0 0 0-6.341 6.339v22.3h6.955V30.696h7.772v-5.727h-7.772v-4.093a1.586 1.586 0 0 1 1.637-1.637h9.002v-5.726H97.642z" fill="none"/></clipPath><clipPath id="e" transform="translate(-.041 -.02)"><path fill="none" d="M81.599 13.514h6.953v28.64h-6.953z"/></clipPath><clipPath id="f" transform="translate(-.041 -.02)"><path d="M67.861 13.514a6.168 6.168 0 0 0-6.341 6.339v22.3h6.956V30.696h7.774v-5.727h-7.774v-4.093a1.583 1.583 0 0 1 1.635-1.637h9v-5.726h-11.25z" fill="none"/></clipPath><clipPath id="g" transform="translate(-.041 -.02)"><path d="M134.584 13.51v5.686h1.986a1.573 1.573 0 0 1 1.625 1.627v21.33h6.907V19.808a6.128 6.128 0 0 0-6.298-6.298h-4.22z" fill="none"/></clipPath><linearGradient id="b" y1="76.629" x2="1" y2="76.629" gradientTransform="rotate(-90 -1006.52 1048.653) scale(28.644)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#d49330"/><stop offset=".083" stop-color="#dfa224"/><stop offset=".229" stop-color="#edb514"/><stop offset=".399" stop-color="#f7c309"/><stop offset=".611" stop-color="#fdcb02"/><stop offset="1" stop-color="#ffcd00"/></linearGradient><clipPath id="h" transform="translate(-.041 -.02)"><path d="M155.47 21.924zm0-.186zm1.311 15.025a2.482 2.482 0 0 1-.955-.571 3.108 3.108 0 0 1-.572-2.21v-.755a2.851 2.851 0 0 1 .572-2.104 2.504 2.504 0 0 1 .955-.57 4.73 4.73 0 0 1 1.418-.17h.006a4.72 4.72 0 0 1 1.417.17 2.496 2.496 0 0 1 .955.57 2.838 2.838 0 0 1 .572 2.104h.001l-.001.054.001.7h-.001a3.094 3.094 0 0 1-.572 2.21 2.475 2.475 0 0 1-.955.572 4.786 4.786 0 0 1-1.417.172h-.006a4.797 4.797 0 0 1-1.418-.173m.216-11.95a2.468 2.468 0 0 1-.955-.57 3.11 3.11 0 0 1-.572-2.21V21.6a2.853 2.853 0 0 1 .572-2.103 2.504 2.504 0 0 1 .955-.57 3.476 3.476 0 0 1 1.202-.171h.006a3.464 3.464 0 0 1 1.201.172 2.496 2.496 0 0 1 .955.569 2.84 2.84 0 0 1 .573 2.103v.432a3.102 3.102 0 0 1-.573 2.21 2.46 2.46 0 0 1-.955.57 3.464 3.464 0 0 1-1.201.172h-.006a3.476 3.476 0 0 1-1.202-.172m-8.091-3.371a7.077 7.077 0 0 0 3.389 5.972 7.384 7.384 0 0 0-3.77 6.456c0 6.729 4.323 8.596 9.661 8.596 5.339 0 9.659-1.868 9.659-8.597a7.407 7.407 0 0 0-3.813-6.456 7.07 7.07 0 0 0 3.39-5.972c0-6.367-4.194-8.192-9.236-8.192s-9.28 1.825-9.28 8.192" fill="none"/></clipPath><linearGradient id="i" y1="76.629" x2="1" y2="76.629" gradientTransform="rotate(-90 -1019.071 1061.514) scale(29.21498)" xlink:href="#b"/><clipPath id="j" transform="translate(-.041 -.02)"><path fill="none" d="M0-.001h211.903v55.677H0z"/></clipPath><clipPath id="k" transform="translate(-.041 -.02)"><path d="M.265 27.84A27.595 27.595 0 1 0 27.862.242 27.595 27.595 0 0 0 .265 27.84" fill="none"/></clipPath><linearGradient id="l" y1="76.629" x2="1" y2="76.629" gradientTransform="rotate(90 2166.66 2166.094) scale(56.17857)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#babfbf"/><stop offset=".11" stop-color="#cacdcc"/><stop offset=".19" stop-color="#d9d9d7"/><stop offset=".356" stop-color="#c4c6c5"/><stop offset=".519" stop-color="#b2bbbc"/><stop offset=".76" stop-color="#a1a3a6"/><stop offset=".961" stop-color="#959698"/><stop offset="1" stop-color="#959698"/></linearGradient><clipPath id="m" transform="translate(-.041 -.02)"><path d="M3.57 27.84A24.29 24.29 0 1 0 27.86 3.55 24.292 24.292 0 0 0 3.57 27.84" fill="none"/></clipPath><linearGradient id="n" y1="76.629" x2="1" y2="76.629" gradientTransform="rotate(-90 -1855.992 1907.974) scale(49.48205)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#dcdddf"/><stop offset="1" stop-color="#818285"/></linearGradient><clipPath id="o" transform="translate(-.041 -.02)"><path d="M3.972 27.838A23.888 23.888 0 1 0 27.859 3.95 23.887 23.887 0 0 0 3.972 27.84" fill="none"/></clipPath><radialGradient id="p" cx="0" cy="76.629" r="1" gradientTransform="rotate(-90 -1320.086 1340.448) scale(35.09412)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset=".472" stop-color="#fff"/><stop offset=".545" stop-color="#f7f7f9"/><stop offset=".658" stop-color="#e2e2e7"/><stop offset=".669" stop-color="#e0dfe5"/><stop offset=".954" stop-color="#d9dae6"/><stop offset="1" stop-color="#d9dae6"/></radialGradient></defs><g clip-path="url(#c)"><path fill="#fff" d="M111.176 13.493h18.685v28.64h-18.685z"/></g><g clip-path="url(#d)"><path fill="#fff" d="M91.26 13.493h17.594v28.64H91.26z"/></g><g clip-path="url(#e)"><path fill="#fff" d="M81.558 13.493h6.953v28.64h-6.953z"/></g><g clip-path="url(#f)"><path fill="#fff" d="M61.479 13.493H79.07v28.64H61.479z"/></g><g clip-path="url(#g)"><path fill="url(#b)" d="M134.543 13.489h10.518v28.644h-10.518z"/></g><g clip-path="url(#h)"><path fill="url(#i)" d="M148.484 13.228h19.32v29.216h-19.32z"/></g><path fill="#fff" d="M182.131 6.188l-13.083 35.948h29.334l13.084-35.948h-29.335z"/><path fill="#326295" d="M182.336 6.481l-12.871 35.364h28.713l12.871-35.364h-28.713z"/><path fill="#fff" d="M176.265 24.016l6.275-17.243h28.091l-6.275 17.243h-28.091zM169.882 41.551l6.275-17.243h28.092l-6.276 17.243h-28.091z"/><path fill="#326295" fill-rule="evenodd" d="M183.867 12.033v6.576h2.047v-2.375h1.473l.523-1.437h-1.996v-1.331h2.479l.524-1.433h-5.05z"/><path fill="#326295" d="M189.542 12.034h2.047v6.576h-2.047z"/><path fill="#326295" fill-rule="evenodd" d="M192.997 12.033v6.576h2.048v-2.375h1.473l.523-1.437h-1.996v-1.331h2.479l.523-1.433h-5.05zM203.907 18.608h-2.068l-.266-.882h-2.314l-.255.882h-2.016l2.395-6.575h2.128zm-2.673-2.146l-.818-2.739-.791 2.74h1.609z"/><g clip-path="url(#j)"><path d="M203.093 13.348a.627.627 0 0 1-.256-.052.661.661 0 0 1-.35-.35.651.651 0 0 1 0-.51.675.675 0 0 1 .141-.209.656.656 0 0 1 .21-.142.656.656 0 0 1 .511 0 .652.652 0 0 1 .208.142.642.642 0 0 1 .141.209.651.651 0 0 1 0 .51.642.642 0 0 1-.14.209.665.665 0 0 1-.209.141.63.63 0 0 1-.256.052m0-.127a.481.481 0 0 0 .351-.15.515.515 0 0 0 .107-.167.551.551 0 0 0 .04-.212.543.543 0 0 0-.04-.213.509.509 0 0 0-.107-.168.486.486 0 0 0-.545-.111.482.482 0 0 0-.158.111.523.523 0 0 0-.106.168.561.561 0 0 0-.039.213.57.57 0 0 0 .04.212.53.53 0 0 0 .105.167.48.48 0 0 0 .158.11.468.468 0 0 0 .194.04m-.254-.905h.277a.35.35 0 0 1 .205.049.195.195 0 0 1 .07.169.184.184 0 0 1-.05.144.24.24 0 0 1-.144.057l.2.326h-.142l-.193-.321h-.084v.321h-.139v-.745zm.14.318h.121a.353.353 0 0 0 .058-.004.14.14 0 0 0 .05-.014.07.07 0 0 0 .032-.033.112.112 0 0 0 .013-.059.09.09 0 0 0-.014-.054.097.097 0 0 0-.034-.03.176.176 0 0 0-.049-.016.476.476 0 0 0-.054-.003h-.124v.213zM179.89 29.083a1.54 1.54 0 0 1 .073-.49.971.971 0 0 1 .216-.369.986.986 0 0 1 .357-.234 1.394 1.394 0 0 1 .492-.08 1.412 1.412 0 0 1 .493.08.94.94 0 0 1 .57.603 1.668 1.668 0 0 1 0 .976.95.95 0 0 1-.218.37.934.934 0 0 1-.356.236 1.54 1.54 0 0 1-.98 0 .954.954 0 0 1-.574-.606 1.531 1.531 0 0 1-.073-.486m.625 0a1.339 1.339 0 0 0 .028.271.802.802 0 0 0 .091.232.5.5 0 0 0 .16.161.435.435 0 0 0 .234.06.423.423 0 0 0 .233-.06.471.471 0 0 0 .16-.16.703.703 0 0 0 .09-.233 1.154 1.154 0 0 0 .03-.27 1.185 1.185 0 0 0-.03-.279.675.675 0 0 0-.09-.23.462.462 0 0 0-.16-.158.44.44 0 0 0-.233-.06.453.453 0 0 0-.235.06.49.49 0 0 0-.159.158.768.768 0 0 0-.09.23 1.371 1.371 0 0 0-.029.278M182.649 27.949h1.517v.429h-.913v.497h.874v.428h-.874v.913h-.604v-2.267zM184.618 27.949h1.517v.429h-.913v.497h.874v.428h-.874v.913h-.604v-2.267zM186.633 27.95h.604v2.267h-.604zM189.74 30.164a5.288 5.288 0 0 1-.285.062 2.214 2.214 0 0 1-.387.03 1.796 1.796 0 0 1-.46-.062 1.257 1.257 0 0 1-.42-.199 1.03 1.03 0 0 1-.303-.359 1.128 1.128 0 0 1-.12-.544 1.283 1.283 0 0 1 .098-.518.988.988 0 0 1 .272-.37 1.135 1.135 0 0 1 .412-.22 1.784 1.784 0 0 1 .517-.074 1.657 1.657 0 0 1 .34.034c.112.023.224.05.333.083l-.05.491a1.224 1.224 0 0 0-.29-.12 1.137 1.137 0 0 0-.3-.04.735.735 0 0 0-.292.055.663.663 0 0 0-.366.385.852.852 0 0 0-.05.294.76.76 0 0 0 .057.3.637.637 0 0 0 .395.366.9.9 0 0 0 .305.05 1.33 1.33 0 0 0 .295-.035 1.879 1.879 0 0 0 .27-.083zM190.208 27.95h.604v2.267h-.604zM192.102 27.948h.74l.874 2.27h-.663l-.169-.486h-.85l-.179.485h-.613zm.37.47h-.007l-.292.886h.57zM194.116 27.949h.604v1.818h.936v.449h-1.54v-2.267zM178.791 31.796h.604v1.819h.936v.448h-1.54v-2.267zM180.788 31.796h.604v2.267h-.604zM183.897 34.01a4.363 4.363 0 0 1-.286.063 2.194 2.194 0 0 1-.386.029 1.79 1.79 0 0 1-.46-.061 1.257 1.257 0 0 1-.419-.2 1.037 1.037 0 0 1-.305-.357 1.145 1.145 0 0 1-.119-.544 1.268 1.268 0 0 1 .098-.52 1.01 1.01 0 0 1 .271-.37 1.128 1.128 0 0 1 .412-.22 1.786 1.786 0 0 1 .518-.073 1.664 1.664 0 0 1 .341.034c.111.024.222.05.332.083l-.049.49a1.24 1.24 0 0 0-.29-.12 1.137 1.137 0 0 0-.3-.04.752.752 0 0 0-.293.056.652.652 0 0 0-.223.153.662.662 0 0 0-.143.232.854.854 0 0 0-.05.295.752.752 0 0 0 .057.299.642.642 0 0 0 .395.367.925.925 0 0 0 .305.049 1.279 1.279 0 0 0 .295-.035 1.784 1.784 0 0 0 .27-.083zM184.32 31.796h1.598v.429h-.994v.468h.939v.428h-.939v.514h1.03v.428h-1.634v-2.267zM186.493 31.796h.77l.767 1.54h.006l-.009-1.54h.552v2.267h-.751l-.792-1.549h-.007l.02 1.549h-.556v-2.267zM189.18 33.505a1.222 1.222 0 0 0 .274.106 1.289 1.289 0 0 0 .35.043 1.266 1.266 0 0 0 .138-.008.364.364 0 0 0 .121-.033.202.202 0 0 0 .082-.068.19.19 0 0 0 .031-.11.184.184 0 0 0-.079-.164.745.745 0 0 0-.198-.095 4.008 4.008 0 0 0-.259-.082 1.11 1.11 0 0 1-.258-.113.634.634 0 0 1-.198-.198.702.702 0 0 1 .011-.67.646.646 0 0 1 .233-.212 1.052 1.052 0 0 1 .315-.112 2.088 2.088 0 0 1 .35-.032 2.31 2.31 0 0 1 .316.022 1.493 1.493 0 0 1 .268.063l-.04.468a.944.944 0 0 0-.244-.08 1.412 1.412 0 0 0-.259-.025c-.039 0-.082.001-.128.005a.658.658 0 0 0-.132.025.283.283 0 0 0-.104.065.15.15 0 0 0-.042.116.156.156 0 0 0 .08.141.927.927 0 0 0 .198.084c.08.023.165.05.258.075a.904.904 0 0 1 .258.113.644.644 0 0 1 .2.197.614.614 0 0 1 .078.33.713.713 0 0 1-.085.365.644.644 0 0 1-.224.228.922.922 0 0 1-.319.12 1.892 1.892 0 0 1-.369.034 2.458 2.458 0 0 1-.34-.025 1.992 1.992 0 0 1-.336-.073zM191.304 31.796h1.598v.429h-.994v.468h.939v.428h-.939v.514h1.03v.428h-1.634v-2.267zM194.071 33.615h.234a.727.727 0 0 0 .522-.172.807.807 0 0 0-.003-1.027.732.732 0 0 0-.519-.172h-.234v1.371zm-.604-1.819h.825a2.628 2.628 0 0 1 .543.052 1.092 1.092 0 0 1 .424.18.847.847 0 0 1 .275.346 1.303 1.303 0 0 1 .1.546 1.26 1.26 0 0 1-.102.536.902.902 0 0 1-.278.352 1.148 1.148 0 0 1-.427.195 2.253 2.253 0 0 1-.535.06h-.825v-2.267zM177.397 35.643h.72a1.313 1.313 0 0 1 .77.18.744.744 0 0 1 .01 1.1 1.02 1.02 0 0 1-.662.196H178v.792h-.604v-2.268zm.604 1.046h.156a.675.675 0 0 0 .146-.015.305.305 0 0 0 .119-.051.264.264 0 0 0 .079-.098.316.316 0 0 0 .029-.148.307.307 0 0 0-.03-.146.259.259 0 0 0-.078-.094.338.338 0 0 0-.12-.051.835.835 0 0 0-.145-.013H178v.616zM179.56 35.643h1.079a1.137 1.137 0 0 1 .283.034.677.677 0 0 1 .232.106.49.49 0 0 1 .158.178.523.523 0 0 1 .057.254.624.624 0 0 1-.106.373.55.55 0 0 1-.328.198v.007a.257.257 0 0 1 .114.062.384.384 0 0 1 .076.105.962.962 0 0 1 .06.146c.019.055.042.118.07.187l.22.617h-.628l-.13-.409a2.883 2.883 0 0 0-.086-.24.587.587 0 0 0-.09-.15.233.233 0 0 0-.106-.076.436.436 0 0 0-.145-.02h-.126v.895h-.604v-2.267zm.604.942h.159c.048 0 .099-.002.152-.005a.422.422 0 0 0 .142-.03.267.267 0 0 0 .107-.079.238.238 0 0 0 .042-.149.206.206 0 0 0-.038-.129.259.259 0 0 0-.097-.076.522.522 0 0 0-.14-.035 1.27 1.27 0 0 0-.168-.01h-.16v.513zM181.82 36.777a1.548 1.548 0 0 1 .073-.49.987.987 0 0 1 .216-.37.971.971 0 0 1 .357-.232 1.532 1.532 0 0 1 .983 0 .943.943 0 0 1 .356.233.974.974 0 0 1 .216.369 1.671 1.671 0 0 1 0 .977.964.964 0 0 1-.218.37.943.943 0 0 1-.356.235 1.526 1.526 0 0 1-.981 0 .95.95 0 0 1-.573-.605 1.542 1.542 0 0 1-.073-.487m.625 0a1.339 1.339 0 0 0 .028.27.791.791 0 0 0 .09.233.48.48 0 0 0 .16.16.435.435 0 0 0 .235.06.423.423 0 0 0 .233-.06.463.463 0 0 0 .159-.16.695.695 0 0 0 .09-.232 1.154 1.154 0 0 0 .03-.271 1.19 1.19 0 0 0-.03-.278.675.675 0 0 0-.09-.23.462.462 0 0 0-.16-.158.44.44 0 0 0-.232-.06.453.453 0 0 0-.235.06.48.48 0 0 0-.16.158.768.768 0 0 0-.09.23 1.379 1.379 0 0 0-.028.278M184.595 35.643h.826a2.684 2.684 0 0 1 .542.051 1.09 1.09 0 0 1 .423.181.87.87 0 0 1 .278.346 1.355 1.355 0 0 1 .097.546 1.293 1.293 0 0 1-.1.536.897.897 0 0 1-.28.352 1.153 1.153 0 0 1-.424.195 2.274 2.274 0 0 1-.536.06h-.826v-2.267zm.604 1.82h.234a.736.736 0 0 0 .524-.173.676.676 0 0 0 .18-.514.67.67 0 0 0-.184-.513.733.733 0 0 0-.52-.172h-.234v1.371zM189.24 37.05a1.02 1.02 0 0 1-.071.402.724.724 0 0 1-.203.28.856.856 0 0 1-.316.164 1.566 1.566 0 0 1-.808 0 .856.856 0 0 1-.316-.164.734.734 0 0 1-.203-.28 1.04 1.04 0 0 1-.07-.402v-1.407h.603v1.305a1.089 1.089 0 0 0 .019.213.49.49 0 0 0 .06.175.316.316 0 0 0 .119.12.363.363 0 0 0 .193.044.352.352 0 0 0 .19-.044.305.305 0 0 0 .119-.12.533.533 0 0 0 .063-.175 1.18 1.18 0 0 0 .017-.213v-1.305h.604v1.407zM191.683 37.859a5.334 5.334 0 0 1-.286.062 2.21 2.21 0 0 1-.386.029 1.8 1.8 0 0 1-.46-.062 1.25 1.25 0 0 1-.419-.198 1.054 1.054 0 0 1-.306-.36 1.133 1.133 0 0 1-.119-.543 1.268 1.268 0 0 1 .1-.52.988.988 0 0 1 .27-.368 1.1 1.1 0 0 1 .412-.222 1.787 1.787 0 0 1 .518-.072 1.745 1.745 0 0 1 .341.033c.11.024.221.05.332.083l-.05.49a1.292 1.292 0 0 0-.29-.12 1.174 1.174 0 0 0-.3-.04.756.756 0 0 0-.293.057.65.65 0 0 0-.365.385.844.844 0 0 0-.052.294.752.752 0 0 0 .06.299.64.64 0 0 0 .153.225.657.657 0 0 0 .24.142.903.903 0 0 0 .305.049 1.229 1.229 0 0 0 .296-.035 1.784 1.784 0 0 0 .27-.083zM192.511 36.091h-.56v-.448h1.723v.448h-.559v1.819h-.604v-1.819z" fill="#326295"/><path d="M27.819 55.635A27.817 27.817 0 1 0 0 27.819a27.85 27.85 0 0 0 27.819 27.816" fill="#a4a7aa"/></g><g clip-path="url(#k)"><path fill="url(#l)" d="M.224.222h55.189v55.191H.224z"/></g><g clip-path="url(#m)"><path fill="url(#n)" d="M3.529 3.529h48.58v48.577H3.529z"/></g><g clip-path="url(#j)"><circle cx="27.819" cy="27.818" r="24.289" fill="none" stroke="#b1b7b9" stroke-miterlimit="10" stroke-width="1.035"/></g><g clip-path="url(#o)"><path transform="rotate(-.432 25.064 33.324)" fill="url(#p)" d="M3.793 3.77h48.135v48.136H3.793z"/></g><path fill="#1c3e6f" d="M46.638 32.4v.131h.293v.629h.15v-.629h.296V32.4h-.739z"/><g clip-path="url(#j)"><path d="M48.385 33.16h-.135v-.47a.753.753 0 0 1 .004-.084.262.262 0 0 1-.037.083l-.239.374h-.029l-.239-.379a.381.381 0 0 1-.045-.078c0 .032.012.06.012.083v.47h-.124V32.4h.124l.296.458.295-.458h.117v.76z" fill="#1c3e6f"/><path d="M17.097 12.256h14.808l-2.272 3.613-14.803.007zM27.82 30.365l-18.751.003 4.557-7.248h-3.348l2.277-3.622h13.952l-2.282 3.622h-6.257l-2.31 3.628h10.07l9.204-14.62 11.455 18.237h-4.321l-2.274-3.617h-6.778l2.284-3.632h2.214l-2.58-4.118z" fill="#6d1a26"/><path d="M14.05 38.263a1.52 1.52 0 0 1-.416 1.152 1.436 1.436 0 0 1-1.107.454q-.933-.022-1.868-.042a1.557 1.557 0 0 1-1.117-.483 1.645 1.645 0 0 1-.466-1.153l-.015-.756 1.126.021c.06.235.124.47.184.706a.578.578 0 0 0 .598.452l1.258.026a.436.436 0 0 0 .378-.173.676.676 0 0 0 .127-.449l-.027-.84a.536.536 0 0 0-.538-.632l-1.573-.025a1.532 1.532 0 0 1-1.112-.49 1.686 1.686 0 0 1-.472-1.156l-.024-1.099a1.543 1.543 0 0 1 .432-1.129 1.465 1.465 0 0 1 1.106-.468l1.839.011a1.52 1.52 0 0 1 1.112.46 1.58 1.58 0 0 1 .457 1.148l.007.692c-.38-.005-.762-.008-1.144-.012-.061-.208-.12-.417-.18-.626a.574.574 0 0 0-.584-.449l-1.24-.008a.455.455 0 0 0-.38.177.666.666 0 0 0-.135.45c.002.213.006.428.01.643a.518.518 0 0 0 .534.61l1.576.018a1.534 1.534 0 0 1 1.118.5 1.674 1.674 0 0 1 .496 1.164c.013.437.024.872.04 1.306m5.259-4.674a.662.662 0 0 1 .15.454c-.007.377-.01.754-.012 1.131a.694.694 0 0 1-.156.46.5.5 0 0 1-.394.181h-1.852c.002-.803.009-1.606.023-2.404h1.85a.485.485 0 0 1 .39.178m1.518.2a1.528 1.528 0 0 0-.461-1.143 1.56 1.56 0 0 0-1.152-.476h-3.476c-.07 2.555-.07 5.178.002 7.731h1.36c-.028-.936-.043-1.883-.05-2.835l2.119.001a1.644 1.644 0 0 0 1.645-1.647c.002-.546.005-1.089.013-1.63m11.937-.203a.714.714 0 0 1 .148.455c.003.318.007.637.008.956a.697.697 0 0 1-.143.456.505.505 0 0 1-.391.173h-1.787c-.001-.742-.004-1.484-.01-2.219l1.782.001a.49.49 0 0 1 .393.178m1.795 6.314c-.425-1.05-.864-2.118-1.313-3.19a1.752 1.752 0 0 0 .757-.612 1.658 1.658 0 0 0 .289-.958c-.004-.45-.007-.902-.013-1.352a1.577 1.577 0 0 0-.496-1.143 1.598 1.598 0 0 0-1.17-.476h-3.398c.014 2.54.014 5.192 0 7.731h1.362c.012-.993.018-2.005.02-3.02h1.296c.417 1.014.826 2.026 1.224 3.02h1.442zm5.753-7.73H35.02q.015.616.026 1.24h1.96c.04 2.155.03 4.354-.027 6.49h1.359c.06-2.138.069-4.334.03-6.49l1.97.001q-.012-.622-.027-1.242m6.059 4.63a1.494 1.494 0 0 0-.427-1.113 1.365 1.365 0 0 0-1.065-.46l-1.567.022a.498.498 0 0 1-.533-.603l.007-.65a.698.698 0 0 1 .15-.456.477.477 0 0 1 .395-.182l1.247.003a.543.543 0 0 1 .56.44l.163.615c.367-.002.733-.005 1.1-.006l.014-.675a1.523 1.523 0 0 0-.412-1.12 1.467 1.467 0 0 0-1.081-.463q-.923-.007-1.846-.019a1.53 1.53 0 0 0-1.15.47 1.581 1.581 0 0 0-.483 1.157q-.003.563-.01 1.127a1.591 1.591 0 0 0 .465 1.171 1.464 1.464 0 0 0 1.13.453c.528-.012 1.052-.027 1.578-.039a.48.48 0 0 1 .504.6l-.018.823a.752.752 0 0 1-.151.45.498.498 0 0 1-.387.193l-1.253.052a.508.508 0 0 1-.582-.416l-.156-.702-1.18.038c-.006.258-.015.514-.023.772a1.45 1.45 0 0 0 .424 1.138 1.425 1.425 0 0 0 1.122.404l1.865-.095a1.6 1.6 0 0 0 1.108-.52 1.678 1.678 0 0 0 .466-1.148l.026-1.262M27.4 33.79a1.54 1.54 0 0 0-.48-1.149 1.6 1.6 0 0 0-1.162-.47H23.92a1.61 1.61 0 0 0-1.173.476 1.575 1.575 0 0 0-.494 1.142 207.489 207.489 0 0 0 0 4.463 1.658 1.658 0 0 0 1.667 1.65h1.837a1.596 1.596 0 0 0 1.162-.475 1.579 1.579 0 0 0 .48-1.174v-4.464m-1.52-.2a.664.664 0 0 1 .152.453c-.003 1.323-.003 2.661 0 3.983a.672.672 0 0 1-.152.453.492.492 0 0 1-.396.187h-1.306a.504.504 0 0 1-.405-.188.716.716 0 0 1-.15-.452c-.01-1.323-.01-2.66 0-3.982a.713.713 0 0 1 .15-.455.514.514 0 0 1 .405-.179h1.306a.499.499 0 0 1 .396.18" fill="#1c3e6f"/><path d="M9.19 30.299l4.558-7.246h-3.35l2.195-3.488h13.793l-2.198 3.488h-6.256l-2.394 3.76h10.227l9.167-14.557 11.335 18.043h-4.164L39.83 26.68h-6.693l2.198-3.5h2.3l-2.702-4.308-7.149 11.426H9.19zm7.944-17.976h14.65l-2.189 3.479-14.646.006z" fill="#a92023"/></g></svg>'};

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.4 124.5"><path d="M106.4 57L9 .8C5-1.5 0 1.4 0 6v112.5c0 4.6 5 7.5 9 5.2l97.4-56.2c4-2.4 4-8.2 0-10.5z"/></svg>'};

/***/ }),
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185);
module.exports = __webpack_require__(184);


/***/ })
],[541]);


// WEBPACK FOOTER //
// static/js/app.js